<template>
  <div class="upload-view" :class="{ 'enterprise-upload': enterpriseMode }">
    <CreateDialog ref="createDialogRef" />
    <EnterpriseAdvancedSettings
      v-if="enterpriseMode"
      ref="advancedSettingsRef"
      :model-value="advancedSettings"
      :disable-keep-language="Boolean(currentParam.sourceLang)"
      @confirm="confirmAdvancedSettings"
    />
    <EnterpriseProtectArea
      v-if="enterpriseMode"
      ref="protectAreaRef"
      :file="fileArrs[0]?.file || null"
      :model-value="protectAreaData"
      @confirm="confirmProtectArea"
    />
    <TranslateEngine
      v-if="enterpriseMode"
      v-model="showTranslateEngineDialog"
      :current-engine-id="currentParam.translateEngineId"
      :anchor-rect="translateEngineAnchorRect"
      @select="onModeChange"
    />
    <div class="homepageBg" :class="{ 'has-files': fileArrs.length > 0 }">
      <div class="upload_main" id="canvasDiv">
        <!-- :disabled="getInputDisabled()"  -->
        <el-upload class="upload-demo" ref="uploadRef" id="upload-tranfer" :webkitdirectory="false"
          :mozdirectory="false" :file-list="uploadFiles" :auto-upload="false" :show-file-list="false"
          :disabled="getDisabled()" :drag="!getInputDisabled()" :accept="getInputAccept()" action=""
          :multiple="getInputMultiple()" :on-change="handleUploadFile" :before-upload="handleBeforeUpload">
          <div :class="`${fileArrs.length == 0 ? 'pdfView select-pdfView' : 'pdfView'}`"
            :style="`cursor: ${fileArrs.length == 0 ? 'pointer' : 'auto'}`">
            <!-- <slot v-if="getSlotDisabled()" /> -->
            <div class="translateBottom" v-if="fileArrs.length > 0" @click="((event) => { event.stopPropagation() })">
              <div style="display: flex; flex-direction: column; cursor: default">
                <div class="translateChoose">
                  <div class="translateChoose_top_view">
                    <div class="chooseSelect chooseSelect-column">
                      <div class="chooseSelect-column-item">
                        <div class="k-shake" :class="{ ['k-shakeactive']: shakeAnimation }">
                          <!-- 翻译语言 -->
                          <div class="item-child item-child-left">
                            <el-popover ref="popoverRef" :width="800" trigger="click" popper-class="customLang-popover"
                              placement="bottom-start">
                              <template #reference>
                                <div
                                  class="el-dropdown-link"
                                  :style="{
                                    color: enterpriseMode ? '#1F2329' : '#262626',
                                    fontSize: '13px',
                                    fontWeight: enterpriseMode ? '600' : 'bold',
                                  }"
                                >
                                  {{ translateLangsName == "" ? (enterpriseMode ? $t('enterprise_ui_upload_auto') : $t("upload_auto_check_lang")) : translateLangsName }}
                                  <WorkbenchIcon v-if="enterpriseMode" name="chevron-down" :size="12" class="enterprise-inline-icon" />
                                  <i v-else class="iconfont icon-icon_arrowsdown"
                                    style="font-size: 12px; color: #262626; margin-left: 5px;" />
                                </div>
                              </template>
                              <LangListItem :langs="languages" :currentLang="currentParam.sourceLang" :type="0"
                                :commonLangs="filterCommonLangs" @onChooseLang="onSelectChange" />
                            </el-popover>
                          </div>
                          <WorkbenchIcon
                            v-if="enterpriseMode"
                            name="arrow-left-right"
                            :size="13"
                            class="enterprise-swap-icon"
                            @click="switchLangs"
                          />
                          <i v-else class="iconfont icon-icon_change" @click="switchLangs"
                            style="margin: 0 10px; color: #262626; cursor: pointer" />
                          <div class="item-child item-child-right">
                            <el-popover ref="popoverTargetRef" :width="800" trigger="click"
                              popper-class="customLang-popover" placement="bottom-start">
                              <template #reference>
                                <div
                                  class="el-dropdown-link"
                                  :style="{
                                    color: currentLangsName === ''
                                      ? (showLangError ? '#E14C25' : (enterpriseMode ? '#98A2B3' : '#8C8C8C'))
                                      : (enterpriseMode ? '#1F2329' : '#262626'),
                                    fontSize: '13px',
                                    fontWeight: enterpriseMode ? '400' : 'bold',
                                  }"
                                >
                                  {{ currentLangsName == "" ? $t("choose_translation_language") : currentLangsName }}
                                  <WorkbenchIcon v-if="enterpriseMode" name="chevron-down" :size="12" class="enterprise-inline-icon" />
                                  <i v-else class="iconfont icon-icon_arrowsdown"
                                    style="font-size: 12px; color: #262626; margin-left: 5px;" />
                                </div>
                              </template>
                              <LangListItem :langs="languages" :currentLang="currentParam.targetLang" :type="1"
                                :commonLangs="filterCommonLangs" @onChooseLang="onTargetChange"
                                @onLockLang="onLockLang" />
                            </el-popover>
                          </div>
                        </div>
                        <div class="engineDev">
                          <!-- 选择引擎 -->
                          <button
                            v-if="enterpriseMode"
                            type="button"
                            class="engineDev_tipsTitle enterprise-engine-trigger"
                            @click.stop="openTranslateEngineDialog"
                          >
                            <p class="translate_engine">{{ $t("translate_engine") }}：</p>
                            <div>
                              <p>{{ filterCurrentMode() || 'Doclingo' }}</p>
                              <WorkbenchIcon name="chevron-down" :size="12" class="enterprise-inline-icon" />
                            </div>
                          </button>
                          <el-dropdown trigger="click" placement="bottom-end" popper-class="el-dropdown-translate-mode"
                            class="engine_dropdown" @command="onModeChange" :popper-options="{ offset: [-20, 20] }"
                            v-else>
                            <div class="engineDev_tipsTitle">
                              <p style="color:#262626; font-size: 14px;  font-weight: bold ;" class='translate_engine'>
                                {{
                                  $t("translate_engine") }}：
                              </p>
                              <div style="display: flex;align-items: center;">
                                <el-tooltip
                                  :disabled="!enterpriseMode || !filterCurrentMode()"
                                  :content="$t('enterprise_ui_upload_underlying_model', { model: filterCurrentMode() })"
                                  effect="dark"
                                  placement="top"
                                >
                                  <p
                                    style="color:#262626; font-size: 14px;  font-weight: bold; margin-left: 10px; margin-right: 10px;">
                                    {{ enterpriseMode ? 'Doclingo' : filterCurrentMode() }}</p>
                                </el-tooltip>
                                <WorkbenchIcon v-if="enterpriseMode" name="chevron-down" :size="12" class="enterprise-inline-icon" />
                                <i v-else class="iconfont icon-icon_arrowsdown" style="font-size: 12px; color: #262626;" />
                              </div>
                            </div>
                            <template #dropdown>
                              <div style="max-height: 254px; min-width: 180px; overflow: auto;">
                                <!-- 选择模型 -->
                                <div class="select_mode_view mode-top">
                                  <div class="mode-title">{{ $t("upload_top_select_model") }}</div>
                                </div>
                                <div style="display: flex;align-items: center;">
                                  <p style="color:#8c8c8c; font-size: 12px;  margin-left: 15px; ">
                                    {{ $t('upload_top_select_model_tips') }}
                                    <span @click="gotoCheckHelp"
                                      class="checkHelp">{{ $t('upload_top_select_model_gotoCheck') }}</span>
                                  </p>
                                </div>

                                <div class="mode-top">
                                  <div class="mode-title">{{ $t("normal_engine") }}</div>
                                </div>
                                <el-dropdown-menu>
                                  <el-dropdown-item v-for="(item, index) in userStore.getTranslateModeByType(0)"
                                    :command="item">
                                    <template #default>
                                      <el-popover width="300" trigger="hover" popper-class="engine-popover"
                                        ref="normalPopoverRef" :hide-after="0" effect="dark" placement="right"
                                        :popper-options="popperOptions">
                                        <template #reference>
                                          <div class="mode-engine-dev"
                                            @click="() => { closeNormalPopoverRef(index, 'item') }">
                                            <div class="mode-item">
                                              <div class="iconBg" :style="`background-color: ${item.iconRgbValue}`">
                                                <i class="iconfont" :class="`${item.iconImgUrl}`"
                                                  style="color: white; font-size: 16px; margin-right: 0" />
                                              </div>
                                              <span class="mode-engine-title">{{ item.engineName }}</span>
                                              <!-- <div class="mode-sub-title">{{$t("chat-use-have-all-char").replace("*", item.tokenCostRatio) }}</div> -->
                                              <div class="lock">
                                                <div class="lock-title">x{{ item.tokenCostRatio }}</div>
                                              </div>
                                            </div>
                                          </div>
                                        </template>
                                        <div style="flex-direction: column; display: flex;"
                                          @click="() => { closeNormalPopoverRef(index) }">
                                          <div class="mode-tips-title">{{ $t("engine_cost_char_ratio").replace("*",
                                            item.tokenCostRatio) }}</div>
                                          <div class="mode-tips-title" style="margin-top: 10px;">{{
                                            $t(`${item.engineDescribe}`) }}</div>
                                        </div>
                                      </el-popover>
                                    </template>
                                  </el-dropdown-item>
                                </el-dropdown-menu>
                                <div class="mode-top">
                                  <div class="mode-title">{{ $t("chat_mode_senior_title") }}</div>
                                  <div class="lock" style="margin-left: 6px;"
                                    v-if="!token || (userInfo.vipLevel == 0 && userInfo.validWordsForBag == 0)">
                                    <div class="lock-title">{{ $t('chat_mode_pro') }}</div>
                                  </div>
                                </div>
                                <el-dropdown-menu>
                                  <el-dropdown-item v-for="(item, index) in userStore.getTranslateModeByType(1)"
                                    :command="item">
                                    <template #default>
                                      <el-popover width="300" trigger="hover" popper-class="engine-popover"
                                        ref="charPopoverRef" :hide-after="0" placement="right"
                                        :popper-options="popperOptions" effect="dark">
                                        <template #reference>
                                          <div class="mode-engine-dev"
                                            @click="() => { closeCharPopoverRef(index, 'item'); }">
                                            <div class="mode-item" :style="{ opacity: item.showFlag == 2 ? .3 : 1 }">
                                              <div class="iconBg" :style="`background-color: ${item.iconRgbValue}`">
                                                <i class="iconfont" :class="`${item.iconImgUrl}`"
                                                  style="color: white; font-size: 16px; margin-right: 0" />
                                              </div>
                                              <span class="mode-engine-title">{{ item.engineName }}</span>
                                              <!-- <div class="mode-sub-title">{{$t("chat-use-have-all-char").replace("*", item.tokenCostRatio) }}</div> -->
                                              <div class="lock">
                                                <div class="lock-title">x{{ item.tokenCostRatio }}</div>
                                              </div>
                                            </div>
                                          </div>
                                        </template>
                                        <div style="flex-direction: column; display: flex;"
                                          @click="() => { closeCharPopoverRef(index); }">
                                          <div class="mode-tips-title">{{ $t("engine_cost_char_ratio").replace("*",
                                            item.tokenCostRatio) }}</div>
                                          <div class="mode-tips-title" style="margin-top: 10px;">{{
                                            $t(`${item.engineDescribe}`) }}</div>
                                        </div>
                                      </el-popover>
                                    </template>
                                  </el-dropdown-item>
                                </el-dropdown-menu>
                                <div class="mode-top" v-if="userStore.getTranslateModeByType(2).length">
                                  <div class="mode-title">{{ $t("chat_mode_reasoning_title") }}</div>
                                  <div class="lock" style="margin-left: 6px;"
                                    v-if="!token || (userInfo.vipLevel == 0 && userInfo.validWordsForBag == 0)">
                                    <div class="lock-title">{{ $t('chat_mode_pro') }}</div>
                                  </div>
                                </div>
                                <el-dropdown-menu>
                                  <el-dropdown-item v-for="(item, index) in userStore.getTranslateModeByType(2)"
                                    :command="item" @click.stop>
                                    <template #default>
                                      <el-popover width="auto" trigger="hover" effect="dark"
                                        popper-class="engine-popover" :hide-after="0" placement="right"
                                        :popper-options="popperOptions">
                                        <template #reference>
                                          <div class="mode-engine-dev">
                                            <div class="mode-item" :style="{ opacity: item.showFlag == 2 ? .3 : 1 }">
                                              <div class="iconBg" :style="`background-color: ${item.iconRgbValue}`">
                                                <i class="iconfont" :class="`${item.iconImgUrl}`"
                                                  style="color: white; font-size: 16px; margin-right: 0" />
                                              </div>
                                              <span class="mode-engine-title">{{ item.engineName }}</span>
                                              <!-- <div class="mode-sub-title">{{$t("chat-use-have-all-char").replace("*", item.tokenCostRatio) }}</div> -->
                                              <div class="lock">
                                                <div class="lock-title">x{{ item.tokenCostRatio }}</div>
                                              </div>
                                              <!-- <div class="originalEngine"
                                                v-if="fileInfo && fileInfo.transEngineId == item.engineId">{{
                                                $t("original-engine") }}</div> -->
                                            </div>
                                          </div>
                                        </template>
                                        <div style="flex-direction: column; display: flex;">
                                          <div class="mode-tips-title">{{ $t("engine_cost_char_ratio").replace("*",
                                            item.tokenCostRatio) }}</div>
                                          <div class="mode-tips-title" style="margin-top: 10px;">{{
                                            $t(`${item.engineDescribe}`) }}</div>
                                        </div>
                                      </el-popover>
                                    </template>
                                  </el-dropdown-item>
                                </el-dropdown-menu>
                              </div>
                            </template>
                          </el-dropdown>
                        </div>
                        <!-- OCR -->
                        <div class="checkDev checkDev_margin" v-if="showTranslateImages">
                          <button
                            v-if="enterpriseMode"
                            type="button"
                            class="enterprise-image-setting"
                            @click.stop="handleOcrToggleClick"
                          >
                            <span
                              class="enterprise-checkbox"
                              :class="{ 'is-checked': currentParam.openImage }"
                              aria-hidden="true"
                            >
                              <WorkbenchIcon v-if="currentParam.openImage" name="check" :size="11" />
                            </span>
                            <span>{{ $t("upload_top_btn_tip_title") }}</span>
                            <el-tooltip
                              :content="$t('enterprise_ui_upload_ocr_tooltip')"
                              effect="dark"
                              placement="top"
                            >
                              <WorkbenchIcon name="info" :size="13" class="enterprise-option-info" @click.stop />
                            </el-tooltip>
                          </button>
                          <i v-else class="iconfont icon-icon_nchecked_n"
                            :class="`${currentParam.openImage ? 'icon-icon_check_n' : 'icon-icon_nchecked_n'}`"
                            @click.stop="handleOcrToggleClick" />
                          <div class="checkDev_tipsTitle">
                            <div v-if="!enterpriseMode" class="ocrSummaryContent">
                              <p style="color:#262626; font-size: 14px;  font-weight: bold" @click.stop>
                                {{ $t("upload_top_btn_tip_title") }}</p>
                            </div>
                            <el-popover v-if="!enterpriseMode" :width="254" trigger="hover" effect="dark" popper-class="engine-popover"
                              placement="top">
                              <template #reference @click.stop>
                                <i class="iconfont icon-icon_question"
                                  style="color:#8C8C8C; font-size: 16px; margin-left: 5px" />
                              </template>
                              <div class="popoverTipsDiv">
                                <div class="popoverDiv-title">{{ $t("upload_top_image_tip11") }}</div>
                                <div class="popoverDiv-title">{{ $t("upload_top_image_tip12") }}</div>
                                <div class="popoverDiv-title">{{ $t("upload_top_image_tip13") }}</div>
                                <div class="popoverDiv-title">{{ $t("upload_top_image_tip14") }}</div>
                                <div class="popoverDiv-title">{{ $t("upload_top_image_tip15") }}</div>
                              </div>
                            </el-popover>
                          </div>
                        </div>
                        <!-- MORE -->
                        <div v-if="!enterpriseMode" class="checkDev checkDev_margin">
                          <i class="iconfont icon-icon_nchecked_n"
                            :class="`${moreSetting ? 'icon-icon_check_n' : 'icon-icon_nchecked_n'}`"
                            @click.stop="moreSetting = !moreSetting" />
                          <div class="checkDev_tipsTitle">
                            <p style="color:#262626; font-size: 14px;  font-weight: bold" @click.stop>
                              {{ $t("dcolingo_more_setting") }}</p>
                          </div>
                        </div>

                        <button
                          v-else
                          type="button"
                          class="checkDev checkDev_margin enterprise-more-setting"
                          :class="{ 'is-active': hasAdvancedSettings }"
                          @click.stop="openAdvancedSettings"
                        >
                          <span class="enterprise-checkbox" aria-hidden="true">
                            <WorkbenchIcon v-if="hasAdvancedSettings" name="check" :size="11" />
                          </span>
                          <span>{{ $t("dcolingo_more_setting") }}</span>
                        </button>

                        <div class="translate-setting" v-if="moreSetting && !enterpriseMode">
                          <div class="checkDev checkTermDev_setIcon" style="margin-left: 0;">
                            <div class="checkTermDev1">
                              <TermListComponents :width="`${800}`" @onUpPro="onUpPro('term')"
                                @onUpdataArt="onUpdataArt" :activeIds="termActiveIds" />
                            </div>

                            <div class="checkDev_tipsTitle">
                              <p style="color:#262626; font-size: 14px;  font-weight: bold; white-space: nowrap; overflow: visible;"
                                @click.stop> {{ $t("art_title") }}
                              </p>
                              <el-tooltip effect="dark" placement="top" popper-class="custom-tooltip">
                                <i class="iconfont icon-icon_question"
                                  style="font-size: 16px; line-height: 16px; color: #8C8C8C; margin-left: 4px;cursor: pointer"
                                  @click.stop />
                                <template #content>
                                  <div class="tooltipDiv">
                                    <div class="tooltip-title">{{ $t('art_library_title_tip1') }}</div>
                                    <div class="tooltip-title">{{ $t('art_library_title_tip2') }}</div>
                                    <div class="tooltip-title">{{ $t('art_library_title_tip3') }}</div>
                                    <div class="tooltip-title">{{ $t('art_library_title_tip4') }}</div>
                                    <div class="tooltip-title">{{ $t('art_library_title_please_tip4') }}“<a
                                        :href="appDomains.getHelpArticleUrl('termDatabase', isChina)"
                                        target="_blank" rel="noopener noreferrer" class="folder-link"
                                        style="color:#b5d9f4;text-decoration: underline;">{{
                                          $t("art_library_title_tip5")
                                        }}</a>”
                                    </div>
                                    <div class="tooltip-title">{{ $t('art_library_title_tip6') }}</div>
                                    <div class="tooltip-title">{{ $t('art_library_title_please_tip4') }}“
                                      <a :href="appDomains.getHelpArticleUrl('onlineEditing', isChina)"
                                        target="_blank" rel="noopener noreferrer" class="folder-link"
                                        style="color:#b5d9f4;text-decoration: underline;">{{
                                          $t("art_library_title_tip7")
                                        }}</a>”
                                    </div>
                                  </div>
                                </template>
                              </el-tooltip>
                            </div>
                          </div>
                          <div class="checkDev checkTermDev" style="min-width: 150px;">
                            <TermListComponents :width="`${800}`" @onUpPro="onUpPro('term')" @onUpdataArt="onUpdataArt"
                              :activeIds="termActiveIds" />
                          </div>
                          <!-- 通用领域 -->
                          <div class="checkDev checkTermDev_setIcon">
                            <!-- <i class="iconfont" :class="`${checkTerm ? 'icon-icon_check_n' : 'icon-icon_nchecked_n'}`"
                              @click.stop="onOpenTerm" /> -->
                            <div class="checkTermDev1">
                              <GeneralFieldComponents :promptType="currentParam.promptType" @onUpPro="onUpPro('term')"
                                @onUpdataField="onUpdataField" />
                            </div>

                            <div class="checkDev_tipsTitle">
                              <p style="color:#262626; font-size: 14px;  font-weight: bold; white-space: nowrap; overflow: visible;"
                                @click.stop> {{ $t("general_field_type") }}</p>
                            </div>
                          </div>
                          <div class="checkDev checkTermDev" style="min-width: 150px;">
                            <GeneralFieldComponents :promptType="currentParam.promptType" @onUpPro="onUpPro('term')"
                              @onUpdataField="onUpdataField" />
                          </div>
                          <!-- 忽略项操作 -->
                          <div class="checkDev checkTermDev_setIcon" v-if="ignoreFileType">
                            <div class="checkTermDev1">
                              <ignore :fileType="ignoreFileType" @ignoreValues="ignoreValues"
                                :ignoreValuesList="ignoreValuesList"></ignore>
                            </div>
                            <div class="checkDev_tipsTitle">
                              <p style="color:#262626; font-size: 14px;  font-weight: bold; white-space: nowrap; overflow: visible;"
                                @click.stop> {{ $t("dcolingo_translation_ignored_items") }}
                              </p>
                              <el-tooltip effect="dark" placement="top" popper-class="custom-tooltip">
                                <i class="iconfont icon-icon_question"
                                  style="font-size: 16px; line-height: 16px; color: #8C8C8C; margin-left: 4px;cursor: pointer"
                                  @click.stop />
                                <template #content>
                                  <div class="tooltipDiv">
                                    <p>{{ $t('dcolingo_explanatory_text') }}</p>
                                    <p>{{ $t('dcolingo_ignore_tips1') }}</p>
                                    <p>{{ $t('dcolingo_ignore_tips2') }}</p>
                                  </div>
                                </template>
                              </el-tooltip>
                            </div>
                          </div>
                          <div class="checkDev checkTermDev" style="min-width: 150px;" v-show="ignoreFileType">
                            <ignore :fileType="ignoreFileType" @ignoreValues="ignoreValues"
                              :ignoreValuesList="ignoreValuesList"></ignore>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="display: flex; flex-direction: row; align-items: center;"
                      v-if="token && resultLength == 0">
                      <div class="last_translation" @click="lastTranslate">
                        {{ $t('doclingo_last_translation') }}
                      </div>
                      <el-tooltip effect="dark" placement="top" :content="$t(`account_to_route_title_2`)">
                        <div class="historyBg hidden-md-only hidden-sm-only hidden-xs-only"
                          @click="(event) => onHistory(event)">
                          <i class="iconfont icon-icon_History"
                            style="font-size: 18px;color:#595959; cursor: pointer;" />
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
              <div class="prohibitLayers" @click="((event) => { event.stopPropagation() })" v-if="resultLength > 0" />
            </div>

            <div v-if="enterpriseMode && fileArrs.length > 0" class="enterprise-mode-row" @click.stop>
              <span class="enterprise-mode-row__label">{{ $t('enterprise_ui_upload_translation_mode') }}</span>
              <el-tooltip
                v-for="item in enterpriseModes"
                :key="item.value"
                :content="item.description"
                effect="dark"
                placement="bottom"
              >
                <button
                  type="button"
                  class="enterprise-mode-pill"
                  :class="{
                    'is-active': translateMode === item.value,
                    'is-disabled': isModeDisabled(item.value),
                  }"
                  :disabled="isModeDisabled(item.value)"
                  @click="selectTranslateMode(item.value)"
                >
                  {{ item.label }}
                  <WorkbenchIcon name="circle-help" :size="13" />
                </button>
              </el-tooltip>
            </div>

            <div class="pdfBox" @click="((event => { if (fileArrs.length > 0) event.stopPropagation() }))">
              <UploadItem v-for="(item, index) of fileArrs" :uploadCount="fileArrs && fileArrs.length"
                @onDelete="onDelete" @onPreview="onPreview" @onOpenFile="onOpenFile" @onDownLoad="onDownLoadFile"
                @onResetTranslate="onResetTranslate" @onCancelTranslate="onCancelTranslate"
                :key="item.key" :index="index" :item="item"
                :resultData="translateResults" :translateResults="translateResults" :translateType="0"
                :enterprise-mode="enterpriseMode" />

              <div class="noData" v-if="fileArrs.length == 0">
                <div v-if="fileArrs.length == 0" class="upload-title-group">
                  <div class="addBtnTitle">{{ $t("upload_title") }}</div>
                  <div v-if="enterpriseMode" class="supported-format-text enterprise-supported-format-text">
                    {{ enterpriseSupportedFormatText }}
                  </div>
                  <div v-else class="supported-format-text">{{ $t("upload_supported_excel_formats") }}</div>
                </div>

                <div class="icon-div" v-if="!enterpriseMode && fileArrs.length == 0">
                  <div class="icon-box icon-box-pdf" v-if="getIuputAcceptIconShow('pdf')">
                    <!-- <img class="icon-image" src="assets/images/fileType/icon_pdf.png"> -->
                    <i class="iconfont icon-image icon-icon_pdf6" :style="{ color: '#FF6666' }" />
                  </div>
                  <div class="icon-box icon-box-excel" v-if="getIuputAcceptIconShow('xlsx')">
                    <!-- <img class="icon-image" src="assets/images/fileType/icon_excel.png"> -->
                    <i class="iconfont icon-image icon-icon_xlsl6" :style="{ color: '#3DCF64' }" />
                  </div>
                  <div class="icon-box icon-box-word" v-if="getIuputAcceptIconShow('docx')">
                    <!-- <img class="icon-image" src="assets/images/fileType/icon_word.png"> -->
                    <i class="iconfont icon-image icon-icon_word6" :style="{ color: '#2DA5FF' }" />
                  </div>
                  <div class="icon-box icon-box-pptx" v-if="getIuputAcceptIconShow('pptx')">
                    <!-- <img class="icon-image" src="assets/images/fileType/icon_ppt.png"> -->
                    <i class="iconfont icon-image icon-icon_ppt6" :style="{ color: '#FF6666' }" />
                  </div>
                  <div class="icon-box icon-box-srt" v-if="getIuputAcceptIconShow('srt')">
                    <!-- <img class="icon-image" src="assets/images/fileType/icon_srt.png"> -->
                    <i class="iconfont icon-image icon-icon_srt6" :style="{ color: '#2DA5FF' }" />
                  </div>
                  <div class="icon-box icon-box-epub" v-if="getIuputAcceptIconShow('epub')">
                    <!-- <img class="icon-image" src="assets/images/fileType/icon_epub.png"> -->
                    <i class="iconfont icon-image icon-icon_epub6" :style="{ color: '#3DCF64' }" />
                  </div>
                  <div class="icon-box icon-box-txt" v-if="getIuputAcceptIconShow('txt')">
                    <!-- <img class="icon-image" src="assets/images/fileType/icon_txt8@3x.png"> -->
                    <i class="iconfont icon-image icon-icon_txt6" :style="{ color: '#3DCF64' }" />
                  </div>
                  <div class="icon-box icon-box-png" v-if="getIuputAcceptIconShow('png')">
                    <!-- <img class="icon-image" src="assets/images/fileType/icon_png.png"> -->
                    <i class="iconfont icon-image icon-icon_png6" :style="{ color: '#FF8D66' }" />
                  </div>
                  <div class="icon-box icon-box-jpeg" v-if="getIuputAcceptIconShow('jpeg')">
                    <!-- <img class="icon-image" src="assets/images/fileType/icon_jpeg.png"> -->
                    <i class="iconfont icon-image icon-icon_jpeg6" :style="{ color: '#2DA5FF' }" />
                  </div>
                  <div class="icon-box icon-box-jpg" v-if="getIuputAcceptIconShow('jpg')">
                    <!-- <img class="icon-image" src="assets/images/fileType/icon_pic.png"> -->
                    <i class="iconfont icon-image icon-icon_jpg6" :style="{ color: '#2DA5FF' }" />
                  </div>
                </div>
                <!-- <div class="upload_hint_text_view" v-if="fileArrs.length == 0 && pdfToken">
                  <div class="upload_hint_text">
                    {{$t("upload-topRight-fileSize-tips").replace("*",
                    userStore.getRoleRightConfig().transFileMaxSize)}}
                    {{userStore.getRoleRightConfig().pageMaxSize ? $t("upload-topRight-page-tips").replace("*",
                    userStore.getRoleRightConfig().pageMaxSize) : ""}}
                  </div>
                  <div class="hidden-sm-only hidden-xs-only">
                    <el-popover ref="popoverRef" width="auto" trigger="hover" popper-class="custom-popover">
                      <template #reference>
                        <i class="iconfont icon-icon_problem" style="color:#8C8C8C; font-size: 14px; " />
                      </template>
                      <div class="popoverDiv">
                        <div class="title" v-if='translateType!==-1'>{{$t("upload-tips9")}}</div>
                        <div class="title" v-if='translateType !== -1'>{{$t("upload-tips10")}}</div>
                        <div class="title" v-if="userInfo.vipLevel == 0 && translateType !== -1">{{$t("upload-tips11")}}
                        </div>
                        <div class="title">{{$t("upload-tips7")}}</div>
                        <div class="title">{{$t("upload-tips8")}}</div>
                      </div>
                    </el-popover>
                  </div>
                  <div ref="buttonRef" @click="(event)=>{onClickOutside(event)}"
                    class="hidden-md-only hidden-lg-only hidden-xl-only">
                    <i class="iconfont icon-icon_problem" style="color:#8C8C8C; font-size: 14px; " />
                  </div>
                </div> -->
              </div>
            </div>
            <div class="bottom-upload" v-if="fileArrs.length > 0" @click.stop>
              <div class="bottom-top-item">
                <div class="title">
                  <template v-if="enterpriseMode">{{ $t('upload_bottom_uploadNum').replace('*', fileArrs.length) }}</template>
                  <template v-else>{{ $t("upload_bottom_uploadNum").replace("*", fileArrs.length) }}</template>
                </div>
                <div class="fileRightTitle" style="margin-left: 20px"
                  v-if="fileArrs.length && (userInfo || isAllTranslated)" @click="((event) => { onClearList(event) })">
                  {{ $t("clearList") }}</div>
              </div>
              <div class="bottom-char-item hidden-sm-only hidden-xs-only">
                <template v-if="enterpriseMode">
                  <span class="title">{{ $t('enterprise_ui_upload_available_characters', { count: availableEnterpriseChars }) }}</span>
                  <el-tooltip
                    :content="$t('enterprise_ui_upload_quota_tooltip')"
                    effect="dark"
                    placement="top"
                  >
                    <WorkbenchIcon name="info" :size="13" class="enterprise-quota-info" />
                  </el-tooltip>
                </template>
              </div>
            </div>
          </div>
        </el-upload>
        <div class="usageRecord hidden-sm-only hidden-xs-only" v-if="fileArrs.length == 0 && token">
          <el-tooltip effect="dark" placement="top" :content="$t(`account_to_route_title_2`)">
            <button
              v-if="enterpriseMode"
              type="button"
              class="enterprise-history-record"
              @click="(event) => onHistory(event)"
            >
              <span>{{ $t(`account_to_route_title_2`) }}</span>
            </button>
            <div v-else style="color: #2590E1; font-size: 12px; cursor: pointer" @click="(event) => onHistory(event)">
              {{ $t(`account_to_route_title_2`) }}
            </div>
          </el-tooltip>
        </div>
      </div>
      <div class="upload-bottom" v-if="showTranslateBtn()">
        <div class="upload-bottom-tipsBox hidden-sm-only hidden-xs-only">
        </div>
        <div class="uploadBtns_view">
          <div class="uploadBtns">
            <PDFStatsButton :title="getUploadBtnTitle" :iconFont="getUploadBtnIcon" :isDisable="getUploadBtnStatus"
              :borderStyle="getUploadBtnBorder" :textColor="getUploadBtnColor" :iconFontColor="getUploadBtnColor"
              customFontSize="14px" paddingTop="0 10px" paddingH="0 10" @ButtonClick="(() => buttonUpload())" />
          </div>
          <button
            v-if="isHighFidelityMode"
            type="button"
            class="enterprise-protect-area-button"
            :disabled="!canMarkProtectArea"
            @click.stop="openProtectArea"
          >
            {{ $t('enterprise_ui_upload_protect_area') }}
          </button>
          <el-popover width="auto" :trigger="showLangError ? `click` : ''" effect="dark"
            popper-class="customupload-popover" placement="top">
            <template #reference>
              <div class="translate-btn" :style="`background-color: ${!resultClick ? `#BFBFBF` : enterpriseMode ? '#2B7DE9' : '#2590E1'};
              ${!resultClick ? `pointer-events: none` : `pointer-events: auto`};
              cursor: ${!resultClick ? `auto` : `pointer`}`" @click="(() => { (onTranslate()) })">
                <div :class="{ 'enterprise-translate-button-label': enterpriseMode }"
                  style="color: white; font-size: 14px; font-weight: bold; padding: 0 10px;text-align: center;">
                  {{ getTranslatedStatus }}</div>
              </div>
            </template>
            <div class="popoverError" v-if="showLangError">
              <div class="popoverDiv-error-title">{{ $t("please_target_lang") }}</div>
            </div>
          </el-popover>
          <el-tooltip
            v-if="enterpriseMode"
            :content="$t('enterprise_ui_upload_cost_tooltip')"
            effect="dark"
            placement="top"
          >
            <WorkbenchIcon name="info" :size="14" class="enterprise-translate-info" />
          </el-tooltip>
          <!-- <el-popover :width="!token || userInfo.vipLevel == 0 ? `auto` : 200" trigger="hover"
            popper-class="engine-popover" placement="top" effect="dark">
            <template #reference>
              <i class="iconfont icon-icon_question hidden-sm-only hidden-xs-only"
                style="color:#8C8C8C; font-size: 18px; margin-left: 20px; " />
            </template>
            <div class="popoverDiv" v-if="!token">
              <div class="popoverDiv-title">{{ $t("upload-top-tip") }}</div>
              <div class="popoverDiv-title">{{ $t("upload-top-tip1") }}</div>
            </div>
            <div class="popoverDiv" v-if="userInfo.vipLevel == 0">
              <div class="popoverDiv-title">{{ $t("upload-top-tip") }}</div>
              <div class="popoverDiv-title">{{ $t("upload-top-tip1") }}</div>
            </div>
            <div class="popoverDiv" v-if="userInfo.vipLevel == 1">
              <div class="popoverDiv-title">{{ $t("upload-top-tip2").replace("*",
                userRights.charsLimitPerMon &&
                userRights.charsLimitPerMon.toLocaleString()) }}</div>
            </div>
            <div class="popoverDiv" v-if="userInfo.vipLevel == 2">
              <div class="popoverDiv-title">{{ $t("upload-top-tip3").replace("*",
                userRights.charsLimitPerMon &&
                userRights.charsLimitPerMon.toLocaleString()) }}</div>
            </div>
          </el-popover> -->
          <div class="prohibitLayers" @click="((event) => { event.stopPropagation() })" v-if="resultLength > 0" />
        </div>
      </div>
    </div>
    <!-- <el-dialog v-model="centerDialogVisible" :title="$t('accountLoginOutTip1')" width="90%" destroy-on-close center
      top="50%">
      <div class="popoverDiv-dialog popoverDiv">
        <div class="title" v-if='translateType !== -1'>{{$t("upload-tips9")}}</div>
        <div class="title" v-if='translateType !== -1'>{{$t("upload-tips10")}}</div>
        <div class="title" v-if="userInfo.vipLevel == 0 && translateType !== -1">{{$t("upload-tips11")}}</div>
        <div class="title">{{$t("upload-tips7")}}</div>
        <div class="title">{{$t("upload-tips8")}}</div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="centerDialogVisible = false">
            {{$t('iKnow')}}
          </el-button>
        </div>
      </template>
    </el-dialog> -->
  </div>
  <OcrCostCharDialog :visible="showOcrCostCharDialog" :is-all-pdf="isAllOcrPdf" :ocr-cost-word="ocrCostWord"
    :total-pages="ocrTotalPages" :total-cost="ocrTotalCost" @close="closeOcrCostCharDialog"
    @confirm="confirmOcrCostCharEnable" />
  <CancelTranslateDialog :visible="cancelDialogVisible" :state="cancelDialogState" @confirm="onConfirmCancel"
    @keep="onKeepTranslating" />
</template>

<script setup lang="ts">
const { buildTranslatedDownloadName } = useDownloadFileName()

// import PDFAmplify from './PDFAmplify.vue'
import UploadItem from './uploadItem/index.vue'
import OcrCostCharDialog from '@/components/Translate/OcrCostChar/index.vue'
import { useOcrCostChar } from '@/components/Translate/OcrCostChar/useOcrCostChar'
import CancelTranslateDialog from '@/components/Translate/Dialog/CancelTranslateDialog.vue'
import { useCancelTranslate, type CancelDialogState } from '~/composables/useCancelTranslate'
import LangListItem from '@/components/TranslateComponents/LangListComponents/LangListItem.vue'
import TermListComponents from '@/components/TranslateComponents/TermListComponents/TermListItem.vue'
import GeneralFieldComponents from '@/components/TranslateComponents/GeneralFieldComponents/GeneralFieldItem.vue'
import PDFStatsButton from '@/components/Button/PDFStatsButton.vue'
import CreateDialog from "@/components/Translate/Dialog/CreateDialog.vue"
import EnterpriseAdvancedSettings from './EnterpriseAdvancedSettings.vue'
import type { EnterpriseAdvancedSettingsValue } from './EnterpriseAdvancedSettings.vue'
import EnterpriseProtectArea from './EnterpriseProtectArea.vue'
import TranslateEngine from './TranslateEngine.vue'
import WorkbenchIcon from '@/components/Workbench/WorkbenchIcon.vue'
import { onMounted, inject, onBeforeUnmount, ref, defineExpose, watch, computed, nextTick, toRaw, isProxy } from 'vue'
import eventBus from 'vue3-eventbus'
import { storeToRefs } from "pinia";
import useUserStore from '~/store/modules/user';
import useBasicStore from '~/store/modules/basic'
import { useI18n } from "vue-i18n";
import Toast from "@/utils/toast";
import { useRouter } from 'vue-router'
import { useRuntimeConfig } from "nuxt/app";
import type { ElUpload, ElTooltip, ElPopover } from 'element-plus'
import { ElMessageBox } from 'element-plus'
import TranslateServer from '@/services/TranslateServer';
import TranslatePageServer from '@/services/TranslatePageServer';
import { getMD5FileString } from '@/utils/init';
import {
  ENTERPRISE_TRANSLATION_FORMAT_HINT_TYPES,
  getTranslationFileTypeDisplayList,
  isExcelTranslationExtension,
} from '@/utils/translationFileType'
import { getTranslateEngineDisplayName } from '@/utils/enterpriseTranslate'
const ignore = defineAsyncComponent(() => import("@/components/TranslateComponents/ignore.vue"))
// import { isMobileOrTablet, isMobileSafari } from '@/utils'

const router = useRouter()

const userStore = useUserStore();
const { token, userInfo, userRights, bizTeamInfo, translateEngines } = storeToRefs(userStore);
const basicStore = useBasicStore()
const { commonLanguages, languages, isChina } = storeToRefs(basicStore)
const { t, locale } = useI18n()
const appDomains = useAppDomainConfig()
const createDialogRef = ref()
// const downloadGuideDialogRef = ref<InstanceType<typeof downloadGuideDialog> | null>(null);

interface fileArrsType {
  src: string,
  key: number,
  progress: number,
  success: boolean,
  base64: any,
  name: string,
  size: number,
  pageNumber: number,
  filename?: string,
  ctime: any,
  res: any,
  fileCost?: number,
  type: number,
  fileType: string,
  file: File,
  status: number,
  sourceFileId?: string,
  char?: string
}

interface translateOption {
  translateEngineId: number,
  termIds: string,
  targetLang: string,
  sourceLang: string,
  openImage: boolean,
  promptType: number,
  promptWordIds?: string,
  customizedStyle?: string,
  targetType?: number,
}

let fileArrs = ref<fileArrsType[]>([])  // 上传数组
let repeatArrs = ref<{ key: number, file: File }[]>([])

let fileRecords = ref<Record<string, any>>({})
let currentFile = ref<string>("")
let call = defineEmits(["upDate", "loginDialog", "clear", "taskCompleted", "onRepeatDialog", "checkFileComplete", "onTry",
  "onFileMax", "timerTry", "checkUploadFile", "onLevelVip", "onResetTranslate", "chatNotEnough", "translateSuccess"])
let timer = ref();
let translateResults = ref<Record<string, any>>({})
let isShowTips = ref(false)
let isRequest = false
let uploadIndex = 0
let currentUploadNum = ref(0)
let isCheckPDF = ref(false)
let uploadFiles = ref([])
let uploadRef = ref()
let currentParam = ref<translateOption>({})
let resultClick = ref(false)

const ocrOpenImage = computed({
  get: () => currentParam.value.openImage,
  set: (value: boolean | undefined) => {
    currentParam.value.openImage = value as boolean
  }
})

const {
  closeDialog: closeOcrCostCharDialog,
  confirmEnable: confirmOcrCostCharEnable,
  formatNumber: formatOcrNumber,
  handleToggleClick: handleOcrToggleClick,
  isAllPdf: isAllOcrPdf,
  ocrCostWord,
  showDialog: showOcrCostCharDialog,
  showPdfStats: showOcrPdfStats,
  totalCost: ocrTotalCost,
  totalPages: ocrTotalPages
} = useOcrCostChar({
  files: fileArrs,
  openImage: ocrOpenImage
})

let showLangError = ref(false) // 目标语言未选择显示的错误
let shakeAnimation = ref(false)

let currentLangsName = ref("")
let translateLangsName = ref("")
let checkTerm = ref(false)

const popoverRef = ref();
const popoverTargetRef = ref();
let mode = ref()
const showTranslateEngineDialog = ref(false)
const translateEngineAnchorRect = ref<DOMRect | null>(null)
// 更多设置开关
const moreSetting = ref(false)
// 术语库初始化ids
const termActiveIds = ref('')
const advancedSettingsRef = ref<InstanceType<typeof EnterpriseAdvancedSettings> | null>(null)
const protectAreaRef = ref<InstanceType<typeof EnterpriseProtectArea> | null>(null)
const protectAreaData = ref<Record<string, any[]>>({})
const advancedSettings = ref<EnterpriseAdvancedSettingsValue>({
  activeSections: [],
  optionsActive: {},
  promptWordIds: '',
  customizedStyle: '',
  termIds: '',
})
const translateMode = ref<0 | 2 | 3>(0)
const enterpriseModes = computed(() => [
  { value: 0 as const, label: t('enterprise_ui_upload_mode_standard'), description: t('enterprise_ui_upload_mode_standard_description') },
  { value: 3 as const, label: t('enterprise_ui_upload_mode_high_fidelity'), description: t('enterprise_ui_upload_mode_high_fidelity_description') },
  { value: 2 as const, label: t('enterprise_ui_upload_mode_reading'), description: t('enterprise_ui_upload_mode_reading_description') },
])
let translateId = 0

defineExpose({ onClearAll, onClearRepeat, onContinueRepeat, onAllClearRepeat, onBtnUpload })

watch(
  () => bizTeamInfo.value,
  (newVal, oldVal) => {
    if (oldVal.serviceLevel != newVal.serviceLevel && newVal.serviceLevel > 0) {
      // 普通用户
      mode.value = userStore.getDefaultTranslateMode(1)
      currentParam.value.translateEngineId = mode.value && mode.value.engineId
    }
  },
  {
    deep: true
  }
)

watch(
  () => translateEngines.value,
  (newVal, oldVal) => {
    if (oldVal.serviceLevel != newVal.serviceLevel && newVal.serviceLevel > 0) {
      // 普通用户
      mode.value = userStore.getDefaultTranslateMode(1)
      currentParam.value.translateEngineId = mode.value && mode.value.engineId
    }
  },
  {
    deep: true
  }
)

const props = withDefaults(defineProps<{
  enterpriseMode?: boolean
}>(), {
  enterpriseMode: false,
})
const enterpriseMode = computed(() => props.enterpriseMode)
const enterpriseSupportedFileTypes = computed(() => (
  getTranslationFileTypeDisplayList([...ENTERPRISE_TRANSLATION_FORMAT_HINT_TYPES])
))
const enterpriseSupportedFormatText = computed(() => {
  const formats = enterpriseSupportedFileTypes.value.join(', ')
  const size = Number(userRights.value.transFileMaxSize)
  return Number.isFinite(size) && size > 0
    ? t('upload_supported_formats_with_limit', { formats, size })
    : formats
})

watch(fileArrs, () => {
  checkResultClickStats()
  if (!canSwitchSpecialMode.value && translateMode.value !== 0) {
    translateMode.value = 0
  }
})

watch(() => currentParam.value.sourceLang, (sourceLang) => {
  if (!sourceLang || !advancedSettings.value.optionsActive.language?.length) return
  const optionsActive = {
    ...advancedSettings.value.optionsActive,
    language: [],
  }
  confirmAdvancedSettings({
    ...advancedSettings.value,
    activeSections: advancedSettings.value.activeSections.filter(key => key !== 'language'),
    optionsActive,
    promptWordIds: Object.values(optionsActive).flatMap(ids => ids || []).join(','),
  })
})

const centerDialogVisible = ref(false);

function checkResultClickStats() {
  let show = true
  if (fileArrs.value.length === 0) {
    show = false
  }
  // let characterNum = 0

  fileArrs.value.forEach((item) => {
    if (!item.success || item.status <= 3) {
      show = false
    }
  })

  // if (language.value === "") {
  //   show = false
  // }
  // if (mode.value === null) {
  //   show = false
  // }
  console.log("checkResultClickStats", show)
  resultClick.value = show
}

const availableEnterpriseChars = computed(() => {
  const serviceWords = Number(bizTeamInfo.value?.remainServiceWords || 0)
  const packageWords = Number(bizTeamInfo.value?.remainPackageWords || 0)
  return (serviceWords + packageWords).toLocaleString()
})

const canSwitchSpecialMode = computed(() => {
  return fileArrs.value.length === 1 && fileArrs.value[0]?.type === 1
})

const isHighFidelityMode = computed(() => enterpriseMode.value && translateMode.value === 3)
const isReadMode = computed(() => enterpriseMode.value && translateMode.value === 2)
const isSingleFileOnlyMode = computed(() => isHighFidelityMode.value || isReadMode.value)
const canMarkProtectArea = computed(() => {
  const file = fileArrs.value[0]
  return isHighFidelityMode.value && fileArrs.value.length === 1 && file?.type === 1 && file?.success
})

const hasAdvancedSettings = computed(() => {
  const settings = advancedSettings.value
  return Boolean(
    settings.activeSections.length ||
    settings.promptWordIds ||
    settings.customizedStyle ||
    settings.termIds
  )
})

function isModeDisabled(value: 0 | 2 | 3) {
  return value !== 0 && !canSwitchSpecialMode.value
}

function selectTranslateMode(value: 0 | 2 | 3) {
  if (isModeDisabled(value)) return
  translateMode.value = value
}

function openProtectArea() {
  if (!canMarkProtectArea.value) return
  protectAreaRef.value?.open()
}

function confirmProtectArea(value: Record<string, any[]>) {
  protectAreaData.value = value
}

function openAdvancedSettings() {
  advancedSettingsRef.value?.open()
}

function confirmAdvancedSettings(value: EnterpriseAdvancedSettingsValue) {
  advancedSettings.value = value
  currentParam.value.termIds = value.termIds
  currentParam.value.promptWordIds = value.promptWordIds
  currentParam.value.customizedStyle = value.customizedStyle
}

const getUploadBtnTitle = computed(() => {
  let title = t("upload_top_btn_title")
  let num = fileArrs.value.length
  console.log("getUploadBtnTitle", userRights.value)
  let max = userRights.value.batchUploadLimit == 0 ? 1 : userRights.value.batchUploadLimit
  if (bizTeamInfo.value.serviceLevel > 0) {
    const count = `${num}/${max}`
    title = String(locale.value).startsWith('zh')
      ? `${t("upload_top_btn_title")}（${count}）`
      : `${t("upload_top_btn_title")} (${count})`
  }
  return title
})

const getUploadBtnStatus = computed(() => {
  let isClick = false
  let num = fileArrs.value.length
  let max = userRights.value.batchUploadLimit == 0 ? 1 : userRights.value.batchUploadLimit
  if (num >= max || isSingleFileOnlyMode.value) {
    isClick = true
  }
  return isClick
})

const getUploadBtnBorder = computed(() => {
  let border = '#BFBFBF solid 1px'
  let num = fileArrs.value.length
  let max = userRights.value.batchUploadLimit == 0 ? 1 : userRights.value.batchUploadLimit
  if (isSingleFileOnlyMode.value) {
    border = '#E8EBF0 solid 1px'
  } else if (num >= max) {
    border = '#BB8247 solid 1px'
  } else {
    border = '#2590E1 solid 1px'
  }
  return border
})

const getUploadBtnColor = computed(() => {
  let color = '#BFBFBF'
  let num = fileArrs.value.length
  let max = userRights.value.batchUploadLimit == 0 ? 1 : userRights.value.batchUploadLimit
  if (isSingleFileOnlyMode.value) {
    color = '#C3C9D1'
  } else if (num >= max) {
    color = '#BB8247'
  } else {
    color = '#2590E1'
  }
  return color
})

const getUploadBtnIcon = computed(() => {
  let icon = null
  let num = fileArrs.value.length
  let max = userRights.value.batchUploadLimit == 0 ? 1 : userRights.value.batchUploadLimit
  return icon
})

const isAllTranslated = computed(() => {
  return fileArrs.value.filter(item => translateResults.value[item.filename] && translateResults.value[item.filename].status === 0).length == 0
})

const resultLength = computed(() => {
  return Object.keys(translateResults.value).length
})

const getTranslatedStatus = computed(() => {
  let resultKeys = Object.keys(translateResults.value)
  let transing = false
  for (let i = 0; i < resultKeys.length; i++) {
    let key = resultKeys[i]
    let value = translateResults.value[key]
    if (value.status == 0 || value.status == 3) {
      transing = true
      break;
    }
  }
  if (transing) {
    return t("translateing")
  } else {
    if (resultKeys.length == 0) {
      if (enterpriseMode.value) {
        return t("translateDocuments")
      }
      return (userRights.value.transCountLimit ?
        `${t("translateDocuments")}(${userRights.value.remainTransCountByDay ? userRights.value.remainTransCountByDay : `0`}/${userRights.value.transCountLimit})` : t("translateDocuments"))
    } else {
      return t("translate_btn_complete")
    }
  }
})

const showTranslateImages = computed(() => {
  let isShow = false
  // 最新逻辑：只有 pdf、pptx、docx、xls/xlsx 文件才显示图片翻译选项
  isShow = fileArrs.value.every((item) => [1, 3, 4, 5].includes(item.type))
  return isShow
})

const filterCommonLangs = computed(() => {
  console.log("filterCommonLangs", commonLanguages.value)
  return commonLanguages.value || []
})

const getInputDisabled = () => {
  return false
}

const getDisabled = () => {
  let isDisabled = fileArrs.value.length > 0
  return false;
}

const getInputMultiple = () => {
  if (isSingleFileOnlyMode.value) {
    return false
  }
  if (userRights.value.batchUploadLimit == 1) {
    return false
  }
  if (token.value) {
    return true
  }
  return true
}

const getIuputAcceptIconShow = (fileType: string) => {
  console.log("getIuputAcceptIconShow", userRights.value)
  if (userRights.value.fileTypes) {
    let supportTypes = userRights.value.fileTypes.split(",")
    console.log(supportTypes, 'supportTypes')
    return supportTypes.includes(fileType)
  }
  return true
}

const getInputAccept = () => {
  const supportTypes = getTranslationFileTypeDisplayList(userRights.value.fileTypes)
  const acceptTypes = supportTypes.map(type => `.${type}`)
  const mimeTypes = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/x-subrip',
    'application/octet-stream',
    'text/plain',
  ]

  if (supportTypes.includes('png')) acceptTypes.push('.PNG')
  if (supportTypes.includes('jpg')) acceptTypes.push('.JPG')
  if (supportTypes.includes('jpeg')) acceptTypes.push('.JPEG')
  return [...acceptTypes, ...mimeTypes].join(',')
}

const showTranslateBtn = () => {
  if (fileArrs.value.length > 0) {
    return true
  }
  return false
}

const getFileExtension = (str) => {
  const lastDotIndex = str.lastIndexOf('.');
  return lastDotIndex === -1 ? '' : str.slice(lastDotIndex);
};

const { $loginCom } = useNuxtApp();
const showLogin = () => {
  console.log('showLogin', useNuxtApp())
  $loginCom.open();
}

async function handleUploadFile(file, files) {
  console.log("上传文件～～～～～～", file)

  if (isSingleFileOnlyMode.value) {
    const isPdf = file?.raw?.type === 'application/pdf' || String(file?.name || '').toLowerCase().endsWith('.pdf')
    const exceedsSingleFile = fileArrs.value.length >= 1 || files.length > 1
    if (!isPdf || exceedsSingleFile) {
      Toast(t(isHighFidelityMode.value
        ? 'enterprise_ui_upload_high_fidelity_single_pdf'
        : 'enterprise_ui_upload_reading_single_pdf'))
      uploadRef.value?.clearFiles()
      uploadFiles.value = []
      return
    }
  }

  const forbiddenTypes = ['application/x-msdownload', 'application/x-apple-diskimage'];
  const isForbiddenType = forbiddenTypes.includes(file.raw.type);
  if (isForbiddenType) {
    Toast(t("type_files_are_not_supported"));
    uploadFiles.value = [];
    return
  }
  // 这里没有创建企业，所以不支持上传文件
  if (bizTeamInfo.value && !bizTeamInfo.value.id) {
    createDialogRef.value && createDialogRef.value.open(0)
    uploadFiles.value = [];
    return;
  }
  if (file.raw.name.toLowerCase().endsWith('.zip')) {
    Toast(t("type_files_are_not_supported"));
    uploadFiles.value = [];
    return;
  }
  // Safari 和部分系统不会为旧版 Office/字幕文件返回 MIME，已知安全后缀继续交给后端校验。
  const emptyMimeAllowedExtensions = ['.srt', '.doc', '.docx', '.xls']
  if (file.raw.type == "" && !emptyMimeAllowedExtensions.includes(getFileExtension(file.name).toLowerCase())) {
    uploadFiles.value = []
    return
  }

  if (!token.value) {
    showLogin()
    uploadFiles.value = []
    return
  }

  // let res = !token.value ? await requestCheckFileTranslateing() : null
  // if (res && res.data) {
  //   config.value.visitorTransDoingJson = res.data
  //   call("checkUploadFile", 9999)
  //   uploadFiles.value = []
  //   return
  // }
  // call("onRepeatDialog", {parmaArray: {}, max: true, type: 0, allArray: []})
  // return
  console.log("userStore.getCheckUserUpload()", userStore)
  let data = userStore.getCheckUserUpload()
  if (!data) {
    uploadRef.value && uploadRef.value.clearFiles()
    call("checkUploadFile")
    uploadFiles.value = []
    return
  }

  let count = 0
  for (let i = 0; i < files.length; i++) {
    const file = files[i]
    const fileSize = file.size
    const maxSize = userRights.value.transFileMaxSize * 1024 * 1024
    if (fileSize > maxSize) {
      continue
    }
    count += 1
  }


  console.log("handleUploadFile2222", count)
  currentUploadNum.value = count
  let currentFilesCount = fileArrs.value.length
  setTimeout(async () => {
    uploadFiles.value = []
    console.log("handleUploadFile111", files, currentFilesCount, currentUploadNum.value, userRights.value.batchUploadLimit)
    if (currentFilesCount + currentUploadNum.value > userRights.value.batchUploadLimit) {
      Toast(t("uploadMax"))
      return
    }
    // console.log("handleUploadFile111", file.raw)

    let isBeyond = false
    const fileSize = file.size
    const maxSize = userRights.value.transFileMaxSize * 1024 * 1024
    if (fileSize > maxSize) {
      isBeyond = true
    }

    if (isBeyond) {
      call("onFileMax")
      currentUploadNum.value -= 1
      if (!token.value) {
        checkUploadPDFImageFiles()
      } else {
        // 登陆后需要检测
        checkFilesRepeat()
      }
      return false
    }
    uploadIndex += 1
    if (!token.value) {
      await uploadAddFile(file, uploadIndex)
      checkUploadPDFImageFiles()
    } else {
      // 登陆后需要检测
      await uploadAddFile(file, uploadIndex, true, false)
      checkFilesRepeat()
    }
  }, 100)

  console.log("handleUploadFile@@@@@@@@", currentUploadNum.value, file, files.length)
}

const updateFilePageNumber = (key: number, pageNumber: number) => {
  if (!pageNumber || pageNumber < 1) {
    return
  }

  fileArrs.value.forEach((file) => {
    if (file.key === key && !file.success) {
      file.pageNumber = pageNumber
    }
  })
}

const parsePdfPageNumber = async (file: File) => {
  const pdfFile = await useNuxtApp().$PdfUtils.readSingleFile1(file)
  let pdfDocument: any = null

  try {
    pdfDocument = await useNuxtApp().$PdfUtils.getSinglePdfDocument(pdfFile.result, 'translate')
    return Number(pdfDocument?._totalPage) || 0
  } finally {
    if (pdfDocument?._pdf?.destroy) {
      await pdfDocument._pdf.destroy().catch((error) => {
        console.warn('destroy pdf document failed', error)
      })
    }
  }
}

async function uploadAddFile(file, indexKey, isRepeat: boolean = false, isAdd: boolean = true) {
  // 这里判断是不是压缩文件 / pdf文件
  let fileFmtTypes = file.name.split(".")
  let fileFmtType = ""
  if (fileFmtTypes.length > 1) {
    fileFmtType = fileFmtTypes[fileFmtTypes.length - 1].toLowerCase()
  }
  var fileType = 0
  if (fileFmtType == 'pdf') {
    fileType = 1
  } else if (fileFmtType == 'pptx') {
    fileType = 3
  } else if (fileFmtType == 'doc' || fileFmtType == 'docx') {
    fileType = 4
  } else if (isExcelTranslationExtension(fileFmtType)) {
    fileType = 5
  } else if (fileFmtType == 'zip') {
    fileType = 2
  } else if (fileFmtType == 'rar') {
    fileType = 6
  } else if (fileFmtType == 'epub') {
    fileType = 7
  } else if (fileFmtType == 'srt') {
    fileType = 8
  } else if (fileFmtType == 'png') {
    fileType = 9
  } else if (fileFmtType == 'jpeg') {
    fileType = 10
  } else if (fileFmtType == 'jpg') {
    fileType = 11
  } else if (fileFmtType == 'txt') {
    fileType = 12
  }

  console.log("uploadAddFile##########", fileType, isRepeat, file)
  let fileInfo = file.raw ? file.raw : file
  if (!isRepeat) {
    let fileModel: fileArrsType = {
      src: null,
      key: indexKey,
      progress: 0,
      success: false,
      base64: null,
      name: fileInfo.name,
      size: fileInfo.size,
      pageNumber: 0,
      filename: null,
      ctime: null,
      type: fileType,
      fileType: fileInfo.type,
      res: null,
      file: fileInfo,
      status: 1,
    }
    fileArrs.value.push(fileModel)

    if (fileType == 1) {
      try {
        const pageNumber = await parsePdfPageNumber(fileInfo)
        updateFilePageNumber(indexKey, pageNumber)
      } catch (error) {
        console.error("parsePdfPageNumber failed", error)
      }
    }

    if (isAdd) {
      repeatArrs.value.push({ key: indexKey, file: fileInfo })
    }
  } else {
    repeatArrs.value.push({ key: indexKey, file: fileInfo })
  }
}

async function handleBeforeUpload(file) {
  // handleUploads(file,uploadIndex)
  // 返回 false 以取消自动上传
  return true;
}

async function checkUploadPDFImageFiles() {
  console.log("checkUploadPDFImageFiles===", currentUploadNum.value, repeatArrs.value.length, repeatArrs.value)
  if (currentUploadNum.value == repeatArrs.value.length) {
    // translateUploadGoogleStatistics()
    let allArrs = repeatArrs.value
    isCheckPDF.value = true
    repeatArrs.value = []
    let keys: Record<string, number> = {}
    for (let i = 0; i < allArrs.length; i++) {
      let item = allArrs[i]
      let res = item.res
      let toRawMap = isProxy(res) ? toRaw(res) : res
      let key = item.key
      if (toRawMap) {
        keys[key] = Object.values(toRawMap).length
      }
    }

    // for (let i = 0; i < fileArrs.value.length; i++) {
    //   if (keys[fileArrs.value[i].key] && !fileArrs.value[i].success) {
    //     fileArrs.value[i].pageNum = keys[fileArrs.value[i].key]
    //   }
    // }

    for (let i = 0; i < allArrs.length; i++) {
      let key = allArrs[i].key
      let file = allArrs[i].file
      let md5 = allArrs[i].fileMD5
      handleUploads(file, key, md5)
    }
    isCheckPDF.value = false
  }
}

async function checkFilesRepeat() {
  console.log("checkFilesRepeat===", currentUploadNum.value, repeatArrs.value.length, repeatArrs.value)
  if (currentUploadNum.value == repeatArrs.value.length) {
    // translateUploadGoogleStatistics()
    let allArrs = repeatArrs.value
    let fileMD5s = []
    for (let i = 0; i < allArrs.length; i++) {
      let item = allArrs[i]
      let key = item.key
      let fileMD5 = await getMD5FileString(item.file)
      fileMD5s.push(fileMD5)
      allArrs[i].fileMD5 = fileMD5
    }
    let res = await TranslateServer.getRequestCheckFileMD5({ fileMd5Strings: fileMD5s.join(",") })
    if (res.code == '1') {
      if (res.list) {
        let mapMD5: Record<string, boolean> = {}
        let uploadFileArrs = []
        let unUploadFileArrs = []
        // 获取所有重复md5的文件
        for (let i = 0; i < res.list.length; i++) {
          let item = res.list[i]
          let fileMD5 = item.fileMd5String
          mapMD5[fileMD5] = true
        }
        // 这里区分文件是否重复
        for (let i = 0; i < allArrs.length; i++) {
          let item = allArrs[i]
          let fileMD5 = item.fileMD5
          if (!mapMD5[fileMD5]) {
            await uploadAddFile(item.file, item.key, false, false)
            uploadFileArrs.push(item)
          } else {
            unUploadFileArrs.push(item)
          }
        }
        console.log("checkFilesRepeat=== 3333", uploadFileArrs, fileArrs.value)
        // checkUploadPDFImageFiles()
        // 这里记录页数

        for (let i = 0; i < uploadFileArrs.length; i++) {
          let item = uploadFileArrs[i]
          let res = item.res
          let toRawMap = isProxy(res) ? toRaw(res) : res
          let key = item.key
          if (toRawMap) {
            fileArrs.value.forEach((file) => {
              if (key == file.key && !file.success) {
                file.pageNumber = Object.values(toRawMap).length
              }
            })
          }
          let file = item.file
          let md5 = item.fileMD5
          handleUploads(file, key, md5)
        }

        let json = { parmaArray: res.list, max: res.list == uploadFileArrs.length, type: 0, allArray: unUploadFileArrs }
        console.log("checkFilesRepeat=== 2222", allArrs, res.list)
        call("onRepeatDialog", json)
      } else {
        for (let i = 0; i < allArrs.length; i++) {
          let item = allArrs[i]
          await uploadAddFile(item.file, item.key, false, false)
        }
        console.log("checkFilesRepeat=== 333", fileArrs.value, allArrs)
        checkUploadPDFImageFiles()
      }
    } else {
      Toast(res.message)
    }
  }
}

const ignoreValuesParams = ref<any>({})
const ignoreValuesList = ref<any>([])

const ignoreValues = (vals, list) => {
  ignoreValuesList.value = list
  ignoreValuesParams.value = vals
  console.log('ignoreValuesParams.value===>>>', ignoreValuesParams.value, ignoreValuesList.value)
}

function handleUploads(file: File, index: number, md5 = null) {
  if (file) {
    // const formData = new FormData()
    // formData.append('localFile', file)
    // if (md5) {
    //   formData.append('fileMd5String', md5)
    // }
    // formData.append('freeTag', '0')
    // const req = { data: formData, key: index }
    const req = { fileRealName: file.name, freeTag: 0, key: index }
    console.log("handleBeforeUpload===> 上传", req, md5)
    // 这里检测通过后 需要改变状态
    for (let i = 0; i < fileArrs.value.length; i++) {
      if (fileArrs.value[i].key == index && !fileArrs.value[i].success) {
        fileArrs.value[i].status = 2
        break
      }
    }
    TranslatePageServer.getAwsUploadFileUrlApi(req).then((data) => {
      console.log("getAwsUploadFileUrlApi===>", data)
      if (data.code === "1") {
        const awsUploadUrl = data.data.awsUploadUrl
        const uploadParams = data.data.uploadParams || {}
        const blobFileName = data.data.blobFileName
        // 使用 XMLHttpRequest 上传文件到 AWS，支持进度回调
        const xhr = new XMLHttpRequest()

        // 监听上传进度
        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable) {
            const progress = parseFloat((event.loaded / event.total).toFixed(2))
            // 通过 eventBus 发送进度事件
            eventBus.emit("onUploadProgress", { key: index, progress: progress })
          }
        }

        // 上传成功
        xhr.onload = () => {
          if (xhr.status === 200 || xhr.status === 204) {
            // 上传成功后，调用后端 API 确认上传完成
            // totalPage：前端 pdf.js 解析出的页数（updateFilePageNumber 写在 fileArrs[key].pageNumber）。
            // AWS 直传路径后端拿不到文件、不会自己数页，pt_source_file.totalPage 全靠这里传；
            // 解析阶段取消翻译的费用 = 页数 × 每页字符数，缺了它预估恒为 0。
            const totalPage = fileArrs.value.find((f) => f.key === index)?.pageNumber || 0
            const confirmParams = {
              blobFileName: blobFileName,
              fileMd5String: md5,
              fileRealName: file.name,
              fileSize: file.size,
              freeTag: 0,
              key: index,
              totalPage
            }

            TranslatePageServer.getAwsUploadFileApi(confirmParams).then((result) => {
              if (result.code === "1") {
                console.log("getAwsUploadFileApi===>", result)
                fileRecords.value[index.toString()] = { ctime: 0, filename: "", key: index, name: "", size: 0 }
                let fileIndex = -1
                for (let i = 0; i < fileArrs.value.length; i++) {
                  if (fileArrs.value[i].key == index && !fileArrs.value[i].success) {
                    fileArrs.value[i].success = true
                    fileArrs.value[i].progress = 1
                    fileArrs.value[i].status = 4
                    fileArrs.value[i].name = file.name
                    fileArrs.value[i].size = file.size
                    fileArrs.value[i].filename = result.data.tmpFileName || result.data.filename
                    fileArrs.value[i].sourceFileId = result.data.sourceFileId
                    fileArrs.value[i].fileCost = result.data.costScore
                    fileIndex = i
                    break
                  }
                }
                checkResultClickStats()
              } else {
                // 上传确认失败
                for (let i = 0; i < fileArrs.value.length; i++) {
                  if (fileArrs.value[i].key == index && !fileArrs.value[i].success) {
                    fileArrs.value[i].status = 5
                    fileArrs.value[i].name = file.name
                    break
                  }
                }
                onClear(index)
                Toast(result.message || t('enterprise_ui_upload_failed'))
              }
            }).catch((error) => {
              console.error("getAwsUploadFileApi error===>", error)
              for (let i = 0; i < fileArrs.value.length; i++) {
                if (fileArrs.value[i].key == index && !fileArrs.value[i].success) {
                  fileArrs.value[i].status = 5
                  fileArrs.value[i].name = file.name
                  break
                }
              }
              onClear(index)
              Toast(error.message || t('enterprise_ui_upload_failed'))
            })
          } else {
            // AWS 上传失败
            for (let i = 0; i < fileArrs.value.length; i++) {
              if (fileArrs.value[i].key == index && !fileArrs.value[i].success) {
                fileArrs.value[i].status = 5
                fileArrs.value[i].name = file.name
                break
              }
            }
            onClear(index)
            Toast(t('enterprise_ui_upload_failed'))
          }
        }

        // 上传错误
        xhr.onerror = () => {
          console.error("AWS upload error===>", xhr)
          for (let i = 0; i < fileArrs.value.length; i++) {
            if (fileArrs.value[i].key == index && !fileArrs.value[i].success) {
              fileArrs.value[i].status = 5
              fileArrs.value[i].name = file.name
              break
            }
          }
          onClear(index)
          Toast(t('enterprise_ui_upload_failed'))
        }

        // 开始上传（使用 PUT 方法上传到 AWS）
        xhr.open('PUT', awsUploadUrl)
        // 设置必要的请求头
        if (uploadParams.contentType) {
          xhr.setRequestHeader('Content-Type', uploadParams.contentType)
        } else {
          // 如果没有指定，使用文件的 MIME 类型
          xhr.setRequestHeader('Content-Type', file.type || 'application/octet-stream')
        }
        // 如果后端返回了其他需要设置的请求头（如签名相关的），可以在这里设置
        if (uploadParams.headers && typeof uploadParams.headers === 'object') {
          Object.keys(uploadParams.headers).forEach(key => {
            xhr.setRequestHeader(key, uploadParams.headers[key])
          })
        }
        // 发送文件
        xhr.send(file)
      } else {
        // 获取上传 URL 失败
        for (let i = 0; i < fileArrs.value.length; i++) {
          if (fileArrs.value[i].key == index && !fileArrs.value[i].success) {
            fileArrs.value[i].status = 5
            fileArrs.value[i].name = file.name
            break
          }
        }
        onClear(index)
        Toast(data.message || t('enterprise_ui_upload_failed'))
      }
    }).catch((error) => {
      console.error("getAwsUploadFileUrlApi error===>", error)
      for (let i = 0; i < fileArrs.value.length; i++) {
        if (fileArrs.value[i].key == index && !fileArrs.value[i].success) {
          fileArrs.value[i].status = 5
          fileArrs.value[i].name = file.name
          break
        }
      }
      onClear(index)
      if (error.code == "20005" || error.code == "20006" || error.code == "20008") {
        call("loginDialog")
      } else if (error.code == "20015") {
        if (!token.value) {
          call("checkUploadFile", -1)
        } else {
          call("checkUploadFile", 2)
        }
      } else if (error.code == "20016") {
        call("checkUploadFile", 3)
      }
      Toast(error.message || t('enterprise_ui_upload_failed'))
    })
    // TranslateServer.getUploadFile(req).then((data)=> { 
    //   if (data.code === "1") {
    //     console.log("getPDFTranslateUpload==", data)
    //     fileRecords.value[data.key.toString()] = {ctime: 0, filename: "", key: data.key, name: "", size: 0}
    //     let index = -1
    //     for (let i = 0; i < fileArrs.value.length; i++) {
    //       if (fileArrs.value[i].key == data.key && !fileArrs.value[i].success) {
    //         fileArrs.value[i].success = true
    //         fileArrs.value[i].progress = 1
    //         fileArrs.value[i].status = 4
    //         fileArrs.value[i].name = file.name
    //         fileArrs.value[i].size = file.size
    //         fileArrs.value[i].filename = data.data.tmpFileName
    //         fileArrs.value[i].sourceFileId = data.data.sourceFileId
    //         fileArrs.value[i].fileCost = data.data.costScore
    //         index = i
    //         break
    //       }
    //     }
    //     checkResultClickStats()
    //   }else {
    //     for (let i = 0; i < fileArrs.value.length; i++) {
    //       if (fileArrs.value[i].key == index && !fileArrs.value[i].success) {
    //         fileArrs.value[i].status = 5
    //         fileArrs.value[i].name = file.name
    //         break
    //       }
    //     }
    //     onClear(index)
    //     Toast(data.message)
    //   }
    // }).catch((error)=>{
    //   onClear(index)
    //   console.log("handleBeforeUpload===> 上传 error", error, fileArrs.value)
    //   if (error) {
    //     if (error.code == "20005" || error.code == "20006" || error.code == "20008") {
    //       call("loginDialog")
    //     }else if (error.code == "20015"){
    //       if (!token.value) {
    //         call("checkUploadFile", -1)
    //       }else {
    //         call("checkUploadFile", 2)
    //       }
    //     }else if (error.code == "20016"){
    //       call("checkUploadFile", 3)
    //     }
    //     for (let i = 0; i < fileArrs.value.length; i++) {
    //       if (fileArrs.value[i].key == index && !fileArrs.value[i].success) {
    //         fileArrs.value[i].status = 5
    //         fileArrs.value[i].name = file.name
    //         break
    //       }
    //     }
    //     Toast(error.message)
    //   }
    // })
  }
}

function onHistory(e: Event) {
  e.stopPropagation()
  router.push({ path: '/account', query: { menu: 'records' } })
}

onBeforeUnmount(() => {
  eventBus.off("onUploadProgress")
  eventBus.off("LoginOutSuccess")
  endTimer()
})

onMounted(() => {
  eventBus.on("onUploadProgress", (e) => {
    for (let i = 0; i < fileArrs.value.length; i++) {
      if (fileArrs.value[i].key == e.key && !fileArrs.value[i].success) {
        fileArrs.value[i].progress = e.progress >= 1 ? 0.99 : e.progress
        console.log("lg =>>>>", e.progress, fileArrs.value[i].progress)
        break
      }
    }
  })
  eventBus.on('LoginOutSuccess', (data) => {
    console.log("LoginOutSuccess")
    onClearAll()
  });

  if (bizTeamInfo.value.serviceLevel > 0) {
    // 普通用户
    mode.value = userStore.getDefaultTranslateMode(1)
    currentParam.value.translateEngineId = mode.value && mode.value.engineId
  }
})

// 源语言
function onSelectChange(codeData) {
  if (codeData.isCommon) {
    currentParam.value.targetLang = codeData.targetCode
    currentParam.value.sourceLang = codeData.sourceCode
    if (showLangError.value) {
      showLangError.value = false
    }
  } else {
    currentParam.value.sourceLang = codeData.sourceCode
  }
  filterLangsList()
  console.log("onSelectChange", popoverRef.value)
  popoverRef.value && popoverRef.value.hide()
  checkResultClickStats()
}

// 目标语言
function onTargetChange(codeData) {
  if (codeData.isCommon) {
    currentParam.value.targetLang = codeData.targetCode
    currentParam.value.sourceLang = codeData.sourceCode
  } else {
    currentParam.value.targetLang = codeData.targetCode
  }
  if (showLangError.value) {
    showLangError.value = false
  }
  filterLangsList()
  popoverTargetRef.value && popoverTargetRef.value.hide()
  checkResultClickStats()
}

// 筛选多语言
const filterLangsList = () => {
  let currentName = ""
  let translateName = ""
  for (let i = 0; i < languages.value.length; i++) {
    let item = languages.value[i]
    if (item.code === currentParam.value.targetLang) {
      currentName = item.name
    }
    if (item.code === currentParam.value.sourceLang) {
      translateName = item.name
    }
  }
  currentLangsName.value = currentName
  translateLangsName.value = translateName
}

function switchLangs() {
  let sourceLang = currentParam.value.sourceLang
  let targetLang = currentParam.value.targetLang
  // if (userStore.checkCurrentLangsByLock(sourceLang)) {
  //   checkType.value = 104
  //   checkDialog.value = true
  //   return
  // }
  currentParam.value.sourceLang = targetLang
  currentParam.value.targetLang = sourceLang
  filterLangsList()
  checkResultClickStats()
}

function onLockLang() {
  // checkType.value = 104
  // checkDialog.value = true
  // popoverTargetRef.value && popoverTargetRef.value.hide()
}

// 选择引擎
function openTranslateEngineDialog(event: MouseEvent) {
  const target = event.currentTarget as HTMLElement | null
  translateEngineAnchorRect.value = target?.getBoundingClientRect?.() || null
  showTranslateEngineDialog.value = true
}

function onModeChange(currentItem) {
  let configKey = userStore.getCurrentCoin(locale.value)
  if (currentItem.showFlag == 2) {
    Toast(t('engineMaintenanceProgress'))
    return;
  }
  // if (!token.value) {
  //   if (currentItem.highLevelFlag == 1 || currentItem.highLevelFlag == 2) {
  //     showLogin()
  //     return
  //   }
  // }
  // if (userInfo.value.vipLevel == 0 && currentItem.highLevelFlag != 0 && userInfo.value.validWordsForBag <= 0) {
  //   let membersConfig = userProStore.getProConfig('vip-1month', 'vip-month', configKey)
  //   currentPro.value = { type: 1, currency: configKey, purchaseType: 'year', config: membersConfig }
  //   proDialog.value = true
  //   return
  // }

  // 只有显示的值为1 正常， 才保存值做流程交互
  mode.value = currentItem
  currentParam.value.translateEngineId = currentItem.engineId
}

const filterCurrentMode = () => {
  return getTranslateEngineDisplayName(mode.value, enterpriseMode.value)
}

// 选择引擎去查看
const gotoCheckHelp = () => {
  const link = document.createElement('a');
  link.href = appDomains.getHelpArticleUrl('vipChat', isChina.value);
  link.setAttribute('target', '_blank');
  link.click();
}

const normalPopoverRef = ref([])
const charPopoverRef = ref([])
const closeNormalPopoverRef = (index: number, domItem?: string) => {
  if (normalPopoverRef.value[index] && typeof normalPopoverRef.value[index].hide === 'function') {
    normalPopoverRef.value[index].hide();
  }
};
const closeCharPopoverRef = (index: number, domItem?: string) => {
  if (charPopoverRef.value[index] && typeof charPopoverRef.value[index].hide === 'function') {
    charPopoverRef.value[index].hide();
  }
};

// 更新术语表
function onUpdataArt(artList) {
  let ids = []
  artList.forEach((item) => {
    if (item.id) {
      ids.push(item.id)
    }
  })
  currentParam.value.termIds = ids.join(",")
}

// 更新通用领域
function onUpdataField(fieldItem) {
  if (fieldItem && fieldItem.id) {
    currentParam.value.promptType = fieldItem.id
  }
}

// 升级是vip
function onUpPro(typeStr?: string) {
  // let configKey = userStore.getCurrentCoin(i18n.locale.value)
  // if (!pdfToken.value) {
  //   // loginOpenDialog()
  //   if (typeStr == 'term') {
  //     checkType.value = 200
  //     checkParam.value = { title: i18n.t('dialog_title_login_register'), btnTitle: i18n.t('upload-dialog-go-login'), type: 1}
  //     checkDialog.value = true
  //   }else {
  //     showLogin()
  //   }
  //   return
  // }
  // if (userInfo.value.vipLevel == 0 && userInfo.value.validWordsForBag <= 0) {
  //   let membersConfig = userProStore.getProConfig('svip-1month', 'svip-month', configKey)
  //   currentPro.value = { type: 2, currency: configKey, purchaseType: 'year', config: membersConfig }
  //   proDialog.value = true
  //   return
  // }
  // // 如果是通过术语表触发的这里， 不应该触发图片翻译开关
  // if (typeStr != 'term') {
  //   currentParam.value.openImage = !currentParam.value.openImage
  // }
}

// 弹窗配置
const popperOptions = {
  modifiers: [{
    name: 'offset',
    options: {
      offset: ({ placement, reference, popper }) => {
        if (placement === 'right') {
          return [0, 200 - reference.width];
        } else {
          return [];
        }
      },
    },
  }]
}

function onPreview(index: number) {
  if (index < fileArrs.value.length) {
    let data = fileArrs.value[index]
    document.body.style.overflow = 'hidden'
    currentFile.value = data.base64
  }
}

async function onDelete(index: number) {
  if (index < fileArrs.value.length) {
    let data = fileArrs.value[index]
    call("clear", data)
    if (data && translateResults.value[data.filename]) {
      delete translateResults.value[data.filename]
    }
    delete fileRecords.value[data.key]
    fileArrs.value.splice(index, 1)
    protectAreaData.value = {}
    if (fileArrs.value.length == 0) {
      isShowTips.value = false
    }
    console.log("onDelete", index, fileArrs.value.length)
    checkResultClickStats()
  }
  call("uploadSuccess")
}

// 重新翻译
function onResetTranslate(index: number, item: object,) {
  console.log("onResetTranslate", item)
  if (item.filename && translateResults.value[item.filename]) {
    delete translateResults.value[item.filename]
    call("onResetTranslate")
  }
}

// 下载
function onDownLoadFile(index: number, item: object, currentFileInfo: object) {
  console.log("onTaskCompleted", index, item, currentFileInfo)
  // if (!token.value || userInfo.value.vipLevel == 0) {
  //   getRequestCheckDownloadFile().then((data)=> {
  //     if (data.code === "1") {
  //       // 判断是不是压缩包
  //       let fileNames = item.name.split(".").reverse()[0]
  //       let fileType = "." + fileNames
  //       let filename = ""
  //       let language = ""
  //       let sourceLang = ""
  //       let transEngineType = 0
  //       let translateId = 0
  //       if (item.filename && translateResults.value[item.filename]) {
  //         let value = translateResults.value[item.filename]
  //         translateId = value.translateId
  //         filename = currentFileInfo ? currentFileInfo.remark.compareFileBlobName : value.file.blobFileName
  //         language = value.language
  //         transEngineType = value.transEngineType
  //         sourceLang = value.sourceLang
  //       }
  //       let lastIndex = item.name.lastIndexOf('.');
  //       let origFileName = item.name
  //       if (language) {
  //         let ext = item.name.slice(lastIndex).toLowerCase()
  //         if (ext == ".png" || ext == '.jpeg' || ext == '.jpg') {
  //           ext = '.pdf'
  //         }
  //         origFileName = buildTranslatedDownloadName(...)
  //       }

  //       // let statisticsName = ""
  //       let url = `${useRuntimeConfig().public.downloadUrl}${filename}?originName=${encodeURIComponent(origFileName)}`

  //       const link = document.createElement('a');
  //       link.href = url;
  //       link.download = origFileName;
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //       statisticsName = `${filename}`
  //       // getRequestDownLoadFileStatict({blobFileName: statisticsName}).then((data)=> {})
  //     }
  //   }).catch((error)=>{
  //     if (error) {
  //       if (error.code == '20020') {
  //         call("checkUploadFile", 4)
  //       }else if (error.code == '10019') {
  //         call("checkUploadFile", 5)
  //       }else {
  //         Toast(error.message || "")
  //       }
  //     }
  //   })
  //   return
  // }
  // 判断是不是压缩包
  let fileNames = item.name.split(".").reverse()[0]
  let fileType = "." + fileNames
  let filename = ""
  let language = ""
  let sourceLang = ""
  let transEngineType = 0
  let translateId = 0
  if (item.filename && translateResults.value[item.filename]) {
    let value = translateResults.value[item.filename]
    translateId = value.translateId
    filename = currentFileInfo ? currentFileInfo.remark.compareFileBlobName : value.file.blobFileName
    language = value.language
    transEngineType = value.transEngineType
    sourceLang = value.sourceLang
  }
  let origFileName = item.name
  if (language) {
    origFileName = buildTranslatedDownloadName(item.name, language, {
      separator: '_',
      variant: 'mono',
      convertImageExtToPdf: true,
    });
  }
  let statisticsName = ""
  let url = `${useRuntimeConfig().public.downloadUrl}${filename}?originName=${encodeURIComponent(origFileName)}`
  const link = document.createElement('a');
  link.href = url;
  link.click();
  statisticsName = `${filename}`
  // getRequestDownLoadFileStatict({blobFileName: statisticsName}).then((data)=> {})
}

function onOpenFile(index: number, item: any) {
  let filename = ""
  let blobFileName = ""
  let translateId = 0
  if (item.filename && translateResults.value[item.filename]) {
    let value = translateResults.value[item.filename]
    filename = value.filename
    blobFileName = value.file.blobFileName
    translateId = value.translateId
  }
  console.log("asdadadsad", item, translateResults.value[item.filename])
  let fileString = item.name.split('.').reverse()[0].toLowerCase()
  let routerPath = "/home/PDFTranslate"
  let ext = `.${fileString}`
  if (enterpriseMode.value && translateMode.value === 2 && fileString === 'pdf') {
    const queryKey = blobFileName.replace(/\.[^.]+$/, '')
    const { href } = router.resolve({
      path: '/home/ReadMarkdown',
      query: {
        oldPDF: `${filename}${ext}`,
        newPDF: blobFileName,
        operateRecordId: translateId,
        queryKey,
        filename: item.name,
      },
    })
    const link = document.createElement('a')
    link.setAttribute('href', href)
    link.setAttribute('target', '_blank')
    link.style.display = 'none'
    link.click()
    return
  }
  if (fileString == 'doc' || fileString == 'docx') {
    routerPath = '/home/WordTranslate'
  } else if (isExcelTranslationExtension(fileString)) {
    routerPath = '/home/ExcelTranslate'
  } else if (fileString == 'pptx') {
    routerPath = '/home/PPTXTranslate'
  } else if (fileString == 'txt' || fileString == 'srt') {
    routerPath = '/home/TextTranslate'
  } else if (fileString == 'png' || fileString == 'jpg' || fileString == 'jpeg') {
    routerPath = '/home/ImageTranslate'
  }
  const { href } = router.resolve({
    path: routerPath,
    query: { oldPDF: `${filename}${ext}`, newPDF: blobFileName, operateRecordId: translateId },
  });
  var a = document.createElement('a');
  a.setAttribute('href', href);
  a.setAttribute('target', '_blank');
  a.style.display = 'none';
  a.click();
}

function onClear(index: number) {
  if (fileArrs.value.length > 0) {
    for (let i = 0; i < fileArrs.value.length; i++) {
      let data = fileArrs.value[i]
      if (data.key == index) {
        delete fileRecords.value[data.key]
        fileArrs.value.splice(i, 1)
        protectAreaData.value = {}
      }
    }
    checkResultClickStats()
  }
}

function onClearAll() {
  fileArrs.value = []
  repeatArrs.value = []
  fileRecords.value = {}
  translateResults.value = {}
  isCheckPDF.value = false
  translateMode.value = 0
  protectAreaData.value = {}
  checkResultClickStats()
}

function onClearRepeat(repeats, allArray, type) {
  repeatArrs.value = []
  console.log("onClearRepeat", repeatArrs.value)
}

function onAllClearRepeat(clearArr, allArray) {
  repeatArrs.value = []
  console.log("onAllClearRepeat", repeatArrs.value)
}

async function onContinueRepeat(clearArr, allArray, type) {
  console.log("onContinueRepeat==", type, allArray, clearArr)

  for (let index = 0; index < allArray.length; index++) {
    const item = allArray[index];
    await uploadAddFile(item.file, item.key, false, true)
    handleUploads(item.file, item.key, item.fileMD5)
  }
  repeatArrs.value = []
}

function onClearList(e: Event) {
  fileArrs.value = []
  repeatArrs.value = []
  translateResults.value = {}
  isShowTips.value = false
  call("clear")
  isCheckPDF.value = false
  translateMode.value = 0
  protectAreaData.value = {}

  e.stopPropagation()
}

function getTranslateFileResult() {
  let fileMaps = []
  for (let key in translateResults.value) {
    let value = translateResults.value[key]
    if (!value.filename || !value.language) {
      continue
    }
    let translateResult = translateResults.value[value.filename]
    if (translateResult && translateResult.status == 3 || translateResult.status == 2) {
      fileMaps.push({
        filename: value.name,
        fileType: 0,
        operateRecordId: translateResult.operateRecordId,
        needCharsNum: translateResult.needCharsNum,
        totalCharsNum: translateResult.totalCharsNum,
        status: translateResult.status,
        remainCharsNum: translateResult.remainCharsNum
      })
    }
  }
  fileMaps.sort((a, b) => b.status - a.status)
  console.log("getTranslateFileResult", fileMaps)
  call("chatNotEnough", fileMaps)
}

// 按钮上传
function buttonUpload() {
  if (isSingleFileOnlyMode.value) {
    Toast(t(isHighFidelityMode.value
      ? 'enterprise_ui_upload_high_fidelity_single_pdf'
      : 'enterprise_ui_upload_reading_single_pdf'))
    return
  }
  // let num = fileArrs.value.length
  // let max = userRights.value.batchUploadLimit == 0 ? 1 : userRights.value.batchUploadLimit
  // let configKey = userStore.getCurrentCoin(locale.value)
  // if (userInfo.value.vipLevel == 0) {
  //   console.log("buttonUpload", max, num)
  //   if (num == max) {
  //     checkType.value = 200
  //     checkParam.value = { title: i18n.t('dialog_title_exclusive'), btnTitle: i18n.t('upgrade-now'), type: 2}
  //     checkDialog.value = true
  //     return
  //   }
  // } else if (userInfo.value.vipLevel == 1) {
  //   if (num == max) {
  //     let membersConfig = userProStore.getProConfig('svip-1month', 'svip-month', configKey)
  //     currentPro.value = { type: 2, currency: configKey, purchaseType: 'year', config: membersConfig }
  //     proDialog.value = true
  //     return
  //   }
  // } else if (!pdfToken.value) {
  //   checkType.value = 200
  //   checkParam.value = { title: i18n.t('dialog_title_login_register'), btnTitle: i18n.t('upload-dialog-go-login'), type: 1}
  //   checkDialog.value = true
  //   return;
  // }
  onBtnUpload()
}

const ignoreFileType = computed(() => {
  let uploadArray = fileArrs.value
  // 这里的逻辑处理是， 如果文件只有一个，并且类型是 typeMap 其中的一个，则动态返回类型值。
  // 如果没有文件， 或者多个文件的情况， 返回false 不显示忽略按钮

  // 如果没有上传文件，直接返回空字符串
  if (uploadArray.length !== 1) return false
  // 获取文件类型对应的忽略选项分组；xls/xlsx 共用 xlsx 分组
  const typeMap = {
    3: 'pptx',
    4: 'docx',
    5: 'xlsx'
  }
  const fileType = uploadArray[0].type

  // 只有 PPT、Word、Excel 类型返回对应值，否则返回空字符串
  return typeMap[fileType] || false
})

// 翻译
async function onTranslate() {
  if (resultClick.value) {
    // 检测目标语言
    if (!currentParam.value.targetLang || currentParam.value.targetLang.length === 0) {
      onShowLangError()
      return
    }
    if (isHighFidelityMode.value && !Object.keys(protectAreaData.value).length) {
      try {
        await ElMessageBox.confirm(
          t('enterprise_ui_upload_unprotected_description'),
          t('enterprise_ui_upload_unprotected_title'),
          {
            confirmButtonText: t('cancel_dlg_keep'),
            cancelButtonText: t('enterprise_ui_upload_return_to_marking'),
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
          },
        )
      } catch (action) {
        if (action === 'cancel') openProtectArea()
        return
      }
    }
    onRequestTranslateFile()
  }
}

// 显示语言未选择动画
function onShowLangError() {
  showLangError.value = true
  shakeAnimation.value = true

  setTimeout(() => {
    shakeAnimation.value = false
  }, 1000)
}

// 翻译接口
function onRequestTranslateFile() {
  // dialogShow.value = false

  let commonlylangs = localStorage.getItem("commonlylangs")
  if (commonlylangs) {
    let langs = JSON.parse(commonlylangs).split(",")
    if (langs.length > 2) {
      langs.splice(2);
    }
    if (!langs.includes(currentParam.value.sourceLang)) {
      langs.unshift(currentParam.value.sourceLang)
    }
    if (!langs.includes(currentParam.value.targetLang)) {
      langs.unshift(currentParam.value.targetLang)
    }
    localStorage.setItem("commonlylangs", JSON.stringify(langs.join(",")))
  } else {
    let langs = []
    langs.unshift(currentParam.value.sourceLang)
    langs.unshift(currentParam.value.targetLang)
    localStorage.setItem("commonlylangs", JSON.stringify(langs.join(",")))
  }

  // localStorage.setItem("sourceCode", currentParam.value.sourceLang)
  // localStorage.setItem("targetCode", currentParam.value.targetLang)
  // getLastLanguageConfig()
  // currentParam.value.transEngineType = userStore.getRoleRightConfig().ocrScanFlag == true ? 1 : 0
  for (let i = 0; i < fileArrs.value.length; i++) {
    // translateGoogleStatistics()
    let file = fileArrs.value[i]
    let fileFmtTypes = file.name.split(".")
    let fileFmtType = ""
    if (fileFmtTypes.length > 1) {
      fileFmtType = fileFmtTypes[fileFmtTypes.length - 1]
    }

    let param = {
      targetLang: currentParam.value.targetLang,
      fileKey: file.filename,
      sourceLang: currentParam.value.sourceLang == "" ? null : currentParam.value.sourceLang,
      translateEngineId: currentParam.value.translateEngineId,
      fileFmtType: fileFmtType,
      ocrFlag: currentParam.value.openImage && showTranslateImages.value ? 1 : 0,  //这里补充的逻辑是， 一定要是OCR可选状态下，并且被选中，才使用OCR
      ignoreItems: ignoreValuesParams.value
    }
    if (currentParam.value.termIds && currentParam.value.termIds.length > 0) {
      param.termIds = currentParam.value.termIds
    }

    if (currentParam.value.promptType && currentParam.value.promptType > 0) {
      param.promptType = currentParam.value.promptType
    }

    if (enterpriseMode.value) {
      param.targetType = translateMode.value
      if (currentParam.value.promptWordIds) {
        param.promptWordIds = currentParam.value.promptWordIds
      }
      if (currentParam.value.customizedStyle) {
        param.customizedStyle = currentParam.value.customizedStyle
      }
      if (isHighFidelityMode.value && Object.keys(protectAreaData.value).length) {
        param.editPageInfoJson = protectAreaData.value
      }
    }

    translateResults.value[file.filename] = {}
    // 没有登录的用户直接翻译

    TranslateServer.getRequestTranslate(param).then((result) => {
      if (result.code == "1") {
        translateResults.value[file.filename].loading = 1
        // 记录当前操作ID
        translateId = result.data.id
        translateResults.value[file.filename].filename = file.filename
        translateResults.value[file.filename].language = currentParam.value.targetLang
        translateResults.value[file.filename].sourceLang = currentParam.value.sourceLang
        translateResults.value[file.filename].translateEngineId = currentParam.value.translateEngineId
        translateResults.value[file.filename].name = file.name
        translateResults.value[file.filename].translateId = result.data.id
        translateResults.value[file.filename].file = result.data
        translateResults.value[file.filename].targetType = translateMode.value
        translateResults.value[file.filename].status = 0
        translateResults.value[file.filename].rate = "1%"
      } else {
        translateResults.value[file.filename].loading = 0
        Toast(result.message)
      }
      // 当翻译数量和上传数量对等时
      if (Object.keys(translateResults.value).length == fileArrs.value.length) {
        call("translateSuccess")
      }
      startTimer()
    }).catch((result) => {
      console.log("error ====>", result, file.filename, translateResults.value)
    })
  }
}

function startTimer() {
  endTimer()
  timer.value = setInterval(() => {
    let queryFileString = ""
    let i = 0
    console.log("startTimer", translateResults.value)
    for (let key in translateResults.value) {
      let value = translateResults.value[key]
      if (!value.filename || !value.language) {
        continue
      }
      if (translateResults.value[value.filename] && translateResults.value[value.filename].status > 0) {
        continue
      }
      if (value.filename && !translateResults.value[value.filename]) {
        translateResults.value[value.filename] = { status: 0, rate: "0%" }
      }
      let blobFileName = value.file.blobFileName.split(".").reverse()[0]
      let name = value.file.blobFileName.replace(`.${blobFileName}`, "")
      if (queryFileString.length > 0) {
        queryFileString = queryFileString + "," + name
      } else {
        queryFileString = name
      }
      i += 1
    }

    if (queryFileString.length > 0 && !isRequest) {
      if (!isShowTips.value) {
        isShowTips.value = true
      }
      isRequest = true

      TranslateServer.getRequestTranslateCheckStatus({ queryFileKey: queryFileString }).then((result) => {
        isRequest = false
        if (result && result.code == "1") {

          for (const resultKey in result.data) {
            let resultValue = result.data[resultKey]
            let fileNames = resultKey.split("-")
            let fileName = ""
            if (fileNames.length > 0) {
              fileName = fileNames[0]
            }
            console.log("aaaaaaaaaa=", fileName, translateResults.value, result.data, fileArrs.value[0])
            if (resultValue.status == "success") {
              if (translateResults.value && translateResults.value[fileName]) {
                translateResults.value[fileName].status = 1
                translateResults.value[fileName].costCharsNum = resultValue.costCharsNum
                translateResults.value[fileName].failReason = resultValue.failReason
                translateResults.value[fileName].tryOcrFlag = resultValue.tryOcrFlag
              }

              if (fileArrs.value.length === 1 && fileArrs.value[0].type != 7) {
                console.log('taskCompleted', translateResults.value[fileName])
                call("taskCompleted", translateResults.value[fileName])
              }
              // getTranslateFileResult()
              call("translateSuccess")
            } else if (resultValue.status == "fail") {
              translateResults.value[fileName].status = 2
              translateResults.value[fileName].costCharsNum = resultValue.costCharsNum
              translateResults.value[fileName].failReason = resultValue.failReason
              // Toast(t("TranslateError"))
              // getTranslateFileResult()
              call("translateSuccess")
            } else if (resultValue.status == "notEnough") {
              translateResults.value[fileName].status = 3
              translateResults.value[fileName].totalCharsNum = resultValue.totalCharsNum
              translateResults.value[fileName].needCharsNum = resultValue.totalCharsNum
              translateResults.value[fileName].operateRecordId = resultValue.operateRecordId
              translateResults.value[fileName].remainCharsNum = resultValue.remainCharsNum
              // Toast(t("TranslateError"))
              getTranslateFileResult()
              call("translateSuccess")
            } else if (resultValue.status == "doing" && resultValue.translateRate) {
              translateResults.value[fileName].status = 0
              // 将rate转换成当前的数值
              let currentRate = translateResults.value[fileName].rate || '0%'
              if (currentRate.endsWith('%')) {
                currentRate = currentRate.replace('%', '')
              }
              currentRate = parseFloat(currentRate)
              // 如果resultValue.translateRate > currentRate则进行直接赋值
              if (parseFloat(resultValue.translateRate) > currentRate) {
                translateResults.value[fileName].rate = parseFloat(resultValue.translateRate).toFixed(0) + "%"
              } else {
                // 此时需要判断currentRate小于10则不停的加0-1之间的一个随机数
                if (currentRate < 10) {
                  let addRandom = Math.random()
                  currentRate += addRandom
                  console.log("addRandom ", addRandom, "currentRate", currentRate, currentRate.toFixed(2))
                  translateResults.value[fileName].rate = currentRate.toFixed(2) + "%"
                }
              }
            }
          }
        }
      }).catch((result) => {
        console.log("error ====>", result, queryFileString, translateResults.value)
        for (const argumentsKey in translateResults.value) {
          if (translateResults.value[argumentsKey]) {
            translateResults.value[argumentsKey].status = 2
          }
        }
        Toast(t("TranslateError"))
      })
    }
    call("timerTry")
    // // 检测字符
    // checkUploadFileCharacter()
  }, 2000)
}

function endTimer() {
  clearInterval(timer.value)
}

// 取消翻译：上传区一个定时器轮询批次内全部文件，取消单个文件绝不能 endTimer()
const { dialogVisible: cancelDialogVisible, dialogState: cancelDialogState, openCancelDialog, onConfirmCancel, onKeepTranslating } = useCancelTranslate({
  onCancelled: (state) => markCancelled(state),
  // 终态/失败只提示、不动本地状态：该文件 status 仍是 0，2s 轮询会拿到后端的真实终态
  onFinalState: (finalStatus) => { Toast(finalStatus === 'fail' ? t('cancel_toast_already_failed') : t('cancel_toast_already_done')) },
  onError: (msg) => Toast(msg || t('translateFail')),
})
function onCancelTranslate(item: any) {
  const r = translateResults.value[item.filename]
  if (!r || !r.translateId) return
  // 第三参 contextKey 传 tmpFileName（translateResults 的键），回调里据此定位是哪条记录，避免并发取消时改错文件
  openCancelDialog(Number(r.translateId), item.name || item.filename, item.filename)
}
// 只有服务端确认取消成功才能把 status 置 2：本地一旦置成 >0，轮询就会跳过该文件
// （见 startTimer 里的 status > 0 → continue），后端结果再也没机会纠正它。
// 绝不 endTimer()：同一个定时器在轮询同批其它文件。
function markCancelled(state: CancelDialogState) {
  const key = state.contextKey
  if (!key) return
  const r = translateResults.value[key]
  if (r && r.status === 0) { r.status = 2; r.failReason = 4 }
}

function onBtnUpload() {
  let ref = document.getElementById("upload-tranfer").querySelector('input')
  if (ref) {
    console.log("onBtnUpload", ref)
    ref.click()
  }
}


// 上次翻译按钮事件
const lastTranslate = () => {
  getlastTranslateConfig()
}
// 获取最近一次翻译的接口事件
const getlastTranslateConfig = () => {
  TranslateServer.getRequestLastTranslateConfig({}).then(async res => {
    let { code, data, message } = res
    if (code == '1') {
      translateEngines.value.forEach((item: any) => {
        if (item.engineId == data.translateEngineId) {
          mode.value = item
        }
      })
      currentParam.value.translateEngineId = data.translateEngineId;  //引擎
      currentParam.value.openImage = data.ocrFlag === 1 ? true : false; //OCR
      currentParam.value.targetLang = data.targetLang   //目标语言
      currentParam.value.sourceLang = data.sourceLang   //原语言
      termActiveIds.value = data.termIds //存储术语库选中的值
      currentParam.value.promptType = data.promptType //存储通用领域选中的值
      if (enterpriseMode.value) {
        const settings = await advancedSettingsRef.value?.syncFromLastConfig?.(data)
        if (settings) {
          confirmAdvancedSettings(settings)
        }
      }
      if (data.termIds != null && data.termIds.trim() !== "") {
        checkTerm.value = true
      }
      filterLangsList()
    } else {
      Toast(message)
    }
  })
}


// watch(
//     () => props.resultData,
//     () => {
//       for (let key in props.resultData) {
//         let value = props.resultData[key]
//         if (!value.filename || !value.language) {
//           continue
//         }
//         if (translateResults.value[value.filename] && translateResults.value[value.filename].status > 0) {
//           continue
//         }
//         if (value.filename && !translateResults.value[value.filename]) {
//           translateResults.value[value.filename] = {status: 0, rate: "1%"}
//         }
//       }
//     },
//     {
//       deep: true
//     }
// )

</script>

<style lang="scss" scoped>
@use './index.scss' as *;
</style>

<style lang="scss" scoped>
.enterprise-upload {
  --enterprise-primary: #2b7de9;
  --enterprise-ink: #1f2329;
  --enterprise-sub: #51565d;
  --enterprise-muted: #98a2b3;
  --enterprise-line: #e8ebf0;

  .homepageBg {
    min-height: 0;
    overflow: hidden;
    background: #fff;
    border: 1px solid var(--enterprise-line);
    border-radius: 12px;

    &:not(.has-files) {
      min-height: 270px;

      .upload_main {
        height: auto;
        min-height: 0;
        border: 0;
        border-radius: 0;
      }

      .pdfView,
      .select-pdfView {
        height: auto;
        min-height: 270px;
        justify-content: flex-start;
        align-items: stretch;
      }

      .select-pdfView:hover {
        background: #fff;
      }

      .pdfBox {
        min-height: 160px;
      }
    }

    .upload_main {
      height: auto;
      min-height: 0;
      border: 0;
      border-radius: 0;
    }
  }

  .upload_main {
    border: 0;
    border-radius: 0;
  }

  .noData {
    box-sizing: border-box;
    flex: 1 1 auto;
    min-height: 100%;
    justify-content: center;
    padding: 0;

    .addBtnTitle {
      color: var(--enterprise-ink);
      font-size: 19px;
      font-weight: 800;
      line-height: 28px;
    }

    .upload-title-group {
      width: 100%;
    }
  }

  .enterprise-supported-format-text {
    box-sizing: border-box;
    width: 100%;
    max-width: none;
    margin-top: 18px;
    padding: 0 24px;
    overflow-x: auto;
    overflow-y: hidden;
    color: #697386;
    font-size: 13px;
    line-height: 22px;
    white-space: nowrap;
    overflow-wrap: normal;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .usageRecord {
    z-index: 2;
    top: 14px;
    right: 18px;
    display: flex;
  }

  .enterprise-history-record {
    display: block;
    height: auto;
    padding: 0;
    color: var(--enterprise-primary);
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    background: transparent;
    border: 0;
    cursor: pointer;

    &:hover {
      opacity: .75;
    }
  }

  .pdfView {
    display: flex;
    height: auto;
    min-height: 335px;
    justify-content: flex-start;
    align-items: stretch;
    flex-wrap: nowrap;
  }

  .select-pdfView {
    min-height: 270px;
    justify-content: flex-start;
    align-items: stretch;
  }

  .translateBottom {
    width: 100%;
    min-height: 0;
    margin: 0;
    border-radius: 0;

    .translateChoose {
      min-height: 0;
    }

    .chooseSelect-column {
      width: 100%;
      padding: 14px 18px;

      .chooseSelect-column-item {
        gap: 14px;

        .k-shake,
        .engineDev {
          box-sizing: border-box;
          height: 34px;
          padding: 0 12px;
          background: #f2f4f7;
          border-radius: 8px;
        }

        .k-shake {
          width: 173px;
          gap: 8px;

          .item-child {
            padding: 0;
          }

          .el-dropdown-link {
            gap: 8px;
          }
        }

        .engineDev {
          width: auto;
          min-width: 171px;
          flex: 0 0 auto;

          .enterprise-engine-trigger {
            width: auto;
            min-width: 100%;
            height: 100%;
            padding: 0;
            background: transparent;
            border: 0;
            cursor: pointer;

            > div {
              display: flex;
              align-items: center;
              min-width: max-content;

              p {
                max-width: none;
                overflow: visible;
                text-overflow: clip;
              }
            }
          }

          .engineDev_tipsTitle,
          .translate_engine,
          p {
            flex-shrink: 0;
            white-space: nowrap;
          }

          .engineDev_tipsTitle {
            gap: 6px;

            > p {
              color: var(--enterprise-sub) !important;
              font-size: 13px !important;
              font-weight: 400 !important;
            }

            > div p {
              margin: 0 !important;
              color: var(--enterprise-ink) !important;
              font-size: 13px !important;
              font-weight: 700 !important;
            }
          }
        }
      }
    }

    .last_translation,
    .historyBg {
      display: none;
    }
  }

  .enterprise-inline-icon,
  .enterprise-swap-icon {
    flex: 0 0 auto;
    color: #8f959e;
  }

  .enterprise-swap-icon {
    cursor: pointer;
  }

  .enterprise-image-setting {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0;
    color: var(--enterprise-ink);
    font: inherit;
    font-size: 13px;
    line-height: 19px;
    background: transparent;
    border: 0;
    cursor: pointer;

    .enterprise-checkbox {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 15px;
      height: 15px;
      color: #fff;
      background: #fff;
      border: 1px solid #c3c9d1;
      border-radius: 3px;

      &.is-checked {
        background: var(--enterprise-primary);
        border-color: var(--enterprise-primary);
      }
    }
  }

  .enterprise-option-info {
    color: var(--enterprise-muted);
    cursor: help;
  }

  .checkDev {
    gap: 6px;
    padding: 0;

    .checkDev_tipsTitle {
      margin-left: 0;

      p {
        color: var(--enterprise-ink) !important;
        font-size: 13px !important;
        font-weight: 400 !important;
      }
    }

    .icon-icon_nchecked_n,
    .icon-icon_check_n {
      padding: 0;
      font-size: 17px;
    }
  }

  .enterprise-more-setting {
    color: var(--enterprise-ink);
    font-size: 13px;
    background: transparent;
    border: 0;
    cursor: pointer;

    .enterprise-checkbox {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 15px;
      height: 15px;
      color: #fff;
      background: #fff;
      border: 1px solid #c3c9d1;
      border-radius: 3px;

      .workbench-icon {
        color: #fff;
      }
    }

    &.is-active .enterprise-checkbox {
      background: var(--enterprise-primary);
      border-color: var(--enterprise-primary);
    }

    .iconfont {
      padding: 0;
      color: #fff;
      font-size: 11px;
    }
  }

  .enterprise-mode-row {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 0 18px 14px;

    &__label {
      color: var(--enterprise-sub);
      font-size: 13px;
      font-weight: 600;
    }
  }

  .enterprise-mode-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 34px;
    padding: 0 14px;
    color: var(--enterprise-ink);
    font-size: 13px;
    font-weight: 600;
    background: #fff;
    border: 1px solid #d9dee5;
    border-radius: 17px;
    cursor: pointer;

    .workbench-icon {
      color: var(--enterprise-muted);
    }

    &.is-active {
      color: #fff;
      background: var(--enterprise-primary);
      border-color: var(--enterprise-primary);

      .workbench-icon {
        color: #bfdbfe;
      }
    }

    &.is-disabled {
      color: #c3c9d1;
      background: #f7f9fc;
      cursor: not-allowed;
    }
  }

  .pdfBox {
    min-height: 152px;
    overflow-y: auto;
    border-top: 1px solid #eef1f5;

    :deep(.upload-item) {
      width: 100%;
      min-height: 66px;
      margin: 0;
      padding: 16px 18px;
      border-top: 0;
      border-bottom: 1px solid #f2f4f7;

      .left-title {
        color: var(--enterprise-ink);
        font-size: 13.5px;
        font-weight: 600;
      }

      .icon-image {
        font-size: 20px;
        padding: 7px;
        border-radius: 8px;
      }

    }
  }

  .bottom-upload {
    align-items: center;
    padding: 10px 18px;
    background: #f7f9fc;

    .bottom-top-item {
      gap: 14px;

      .title,
      .fileRightTitle {
        margin-left: 0 !important;
        font-size: 12.5px;
      }

      .title {
        color: var(--enterprise-sub);
      }

      .fileRightTitle {
        color: var(--enterprise-primary);
        font-weight: 600;
      }
    }

    .bottom-char-item {
      width: auto;
      gap: 6px;
      padding: 0;

      .title {
        color: var(--enterprise-sub);
        font-size: 12.5px;
        font-weight: 600;
      }
    }
  }

  .enterprise-quota-info,
  .enterprise-translate-info {
    color: var(--enterprise-muted);
    font-size: 14px;
    cursor: help;
  }

  .homepageBg > .upload-bottom {
    min-height: 66px;
    margin: 0;
    padding: 14px 18px;
    border-top: 1px solid #eef1f5;

    .upload-bottom-tipsBox {
      display: none;
    }

    .uploadBtns_view {
      width: 100%;
      gap: 12px;
      justify-content: flex-end;
      isolation: isolate;

      > .prohibitLayers {
        z-index: 20;
        inset: -2px;
        width: auto;
        height: auto;
        background: rgba(255, 255, 255, .62);
        opacity: 1;
        pointer-events: auto;
      }
    }

    .uploadBtns {
      width: 129px;
      min-width: 129px;
      height: 38px;
      margin: 0;
      border-radius: 8px;
    }

    .translate-btn {
      width: 98px;
      min-width: 98px;
      height: 38px;
      margin: 0;
      border-radius: 8px;

      .enterprise-translate-button-label {
        padding: 0 !important;
        font-size: 13.5px !important;
        font-weight: 700 !important;
        line-height: 20px;
        white-space: nowrap;
      }
    }

    .enterprise-protect-area-button {
      min-width: 104px;
      height: 38px;
      padding: 0 14px;
      color: #fff;
      font-size: 13px;
      font-weight: 700;
      background: #ff8a3d;
      border: 1px solid #ff8a3d;
      border-radius: 8px;
      cursor: pointer;

      &:hover {
        opacity: .86;
      }

      &:disabled {
        background: #c3c9d1;
        border-color: #c3c9d1;
        cursor: not-allowed;
        opacity: 1;
      }
    }

    .translate-btn:hover {
      opacity: .88;
    }

    :deep(.buttonMain),
    :deep(.buttonView) {
      border-radius: 8px !important;
    }
  }
}
</style>


<style lang="scss" scoped>
.customLang-popover.el-popover {
  background-color: #FFFFFF !important;
  border-color: transparent !important;
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.16);
  max-height: 300px;

  .el-popper__arrow::before {
    background: #FFFFFF;
    border-color: transparent;
  }
}

.customupload-popover.el-popover {
  background-color: #303133 !important;
  border-color: transparent !important;
  max-height: 300px;

  .el-popper__arrow::before {
    background: #303133 !important;
    border-color: transparent !important;
    // border-left-color: rgba(255, 255, 255, 0.8)
  }
}

.engine-popover.el-popover {
  background-color: #303133 !important;
  border-color: transparent !important;
  max-height: 300px;

  .el-popper__arrow::before {
    background: #303133 !important;
    border-color: transparent !important;
    // border-left-color: rgba(255, 255, 255, 0.8)
  }
}

.el-dropdown-translate-mode {
  z-index: 888 !important;
}

.mode-top {
  display: flex;
  flex-direction: row;
  padding: 8px 15px 0px 15px;
  align-items: center;

  .mode-title {
    font-size: 12px;
    color: #262626;
    font-weight: bold;
  }

  .lock {
    margin-left: 10px;
    background: linear-gradient(90deg, #FEECDE 0%, #FECD9C 100%);
    border-radius: 2px 2px 2px 2px;
    padding: 2px 5px;

    .lock-title {
      color: #894825;
      font-size: 12px;
      line-height: 12px;
    }
  }
}

.mode-engine-dev {
  display: flex;
  flex-direction: column;

  .mode-subTitle {
    margin-left: 6px;
    color: #8C8C8C;
    font-size: 14px;
    white-space: normal;
  }

  .mode-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 30px;

    .iconBg {
      width: 20px;
      height: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
    }

    .mode-engine-title {
      margin-left: 6px;
      color: #595959;
      font-size: 14px;
    }

    .mode-sub-title {
      color: #8C8C8C;
      font-size: 12px;
      margin-left: 10px;
    }

    .lock {
      margin-left: 10px;
      background: #E5F2FB;
      border-radius: 2px 2px 2px 2px;
      padding: 2px 5px;

      .lock-title {
        color: #595959;
        font-size: 12px;
        line-height: 12px;
      }
    }
  }
}

.mode-tips-title {
  color: #FFFFFF;
  font-size: 12px;
  white-space: normal;
  font-weight: bold;
}

.checkHelp {
  margin-left: 5px;
  color: #2590E1;
  cursor: pointer;
}

.checkHelp:hover {
  opacity: 0.5;
}
</style>
